import React from 'react';

const icons = {
  auction: (
    <svg
      fill="#000000"
      height="24px"
      width="24px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M475.542,203.546c-15.705-15.707-38.776-18.531-57.022-9.796L296.42,71.648c8.866-18.614,5.615-41.609-9.775-56.999 c-19.528-19.531-51.307-19.531-70.837,0L144.97,85.486c-19.529,19.529-19.529,51.307,0,70.836 c15.351,15.353,38.31,18.678,56.999,9.775l25.645,25.645L14.902,404.454c-19.575,19.574-19.578,51.259,0,70.836 c19.575,19.576,51.259,19.579,70.837,0l212.712-212.711l25.642,25.641c-8.868,18.615-5.617,41.609,9.774,57 c9.46,9.46,22.039,14.672,35.419,14.672s25.957-5.21,35.418-14.672l70.837-70.837 C495.072,254.853,495.072,223.077,475.542,203.546z M192.196,132.71c-6.51,6.509-17.103,6.507-23.613,0 c-6.509-6.511-6.509-17.102,0-23.612l70.837-70.837c6.509-6.509,17.1-6.512,23.612,0c6.51,6.51,6.51,17.102,0.001,23.612 L192.196,132.71z M62.127,451.676c-6.526,6.525-17.086,6.526-23.612,0c-6.525-6.525-6.526-17.087,0-23.612l212.712-212.712 l23.612,23.613L62.127,451.676z M227.614,144.516l11.805-11.807l35.419-35.419L392.9,215.353l-47.224,47.225L227.614,144.516z M451.931,250.772l-70.837,70.837c-6.526,6.526-17.086,6.526-23.612,0c-6.51-6.51-6.51-17.103,0-23.613l70.838-70.837 c6.524-6.526,17.086-6.525,23.611,0C458.457,233.684,458.457,244.245,451.931,250.772z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M461.691,411.822H328.12c-27.619,0-50.089,22.47-50.089,50.089v33.393c0,9.221,7.476,16.696,16.696,16.696h200.357 c9.221,0,16.696-7.476,16.696-16.696v-33.393C511.781,434.292,489.311,411.822,461.691,411.822z M478.388,478.607H311.424v-16.696 c0-9.206,7.49-16.696,16.696-16.696h133.571c9.206,0,16.696,7.49,16.696,16.696V478.607z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  paymentIcon: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_78_357)">
        <path
          d="M30.8499 43.0534C30.4669 43.0541 30.1022 42.886 29.8537 42.5944L22.9349 34.4923C22.4649 33.9419 22.53 33.1153 23.0803 32.6453C23.6307 32.176 24.4574 32.2411 24.9273 32.7907L31.0151 39.92L46.1354 27.6188C46.6967 27.162 47.5219 27.2468 47.978 27.8081C48.4348 28.3695 48.35 29.1947 47.7887 29.6507L31.6751 42.7596C31.4427 42.9496 31.151 43.0534 30.8499 43.0534Z"
          fill="#2DE1C2"
        />
        <path
          d="M30.4179 68.3437L33.9687 69.891C34.3005 70.0357 34.6784 70.0364 35.011 69.8924L39.012 68.1646C53.06 62.2647 62.1993 48.5148 62.2008 33.2783V15.3294C62.2008 14.8455 61.934 14.4004 61.5071 14.1731L35.1981 0.154245C34.8078 -0.0540638 34.34 -0.0511404 33.9526 0.161554L8.37155 14.1804C7.95201 14.4106 7.6918 14.8506 7.6918 15.3294V33.6416C7.70715 48.6946 16.6257 62.3129 30.4179 68.3437ZM10.3114 16.1049L34.5907 2.79794L59.5812 16.1144V33.2783C59.5783 47.4645 51.0668 60.2649 37.9865 65.7548L37.977 65.7592L34.4935 67.2634L31.4661 65.9426C18.6277 60.3292 10.3253 47.6538 10.3106 33.6416L10.3114 16.1049Z"
          fill="#087ACB"
        />
        <path
          d="M43.5999 58.2695L43.5911 58.2732L40.1069 59.7781L37.0794 58.4581C24.241 52.8447 15.9386 40.1693 15.924 26.157V13.0284L10.3106 16.1048V33.6415C10.3253 47.6538 18.6276 60.3292 31.4661 65.9426L34.4928 67.2626L37.977 65.7577L37.9858 65.754C45.2364 62.701 51.2613 57.3171 55.1066 50.4546C51.8248 53.7934 47.9137 56.4495 43.5999 58.2695Z"
          fill="#E5F0FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_357">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  payment: (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6V10M17 6V10M1 4.2L1 11.8C1 12.9201 1 13.4802 1.21799 13.908C1.40973 14.2843 1.71569 14.5903 2.09202 14.782C2.51984 15 3.07989 15 4.2 15L17.8 15C18.9201 15 19.4802 15 19.908 14.782C20.2843 14.5903 20.5903 14.2843 20.782 13.908C21 13.4802 21 12.9201 21 11.8V4.2C21 3.0799 21 2.51984 20.782 2.09202C20.5903 1.7157 20.2843 1.40974 19.908 1.21799C19.4802 1 18.9201 1 17.8 1L4.2 1C3.0799 1 2.51984 1 2.09202 1.21799C1.7157 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2ZM13.5 8C13.5 9.38071 12.3807 10.5 11 10.5C9.61929 10.5 8.5 9.38071 8.5 8C8.5 6.61929 9.61929 5.5 11 5.5C12.3807 5.5 13.5 6.61929 13.5 8Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  addIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledAddIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 4V20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  subtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  disabledSubtractIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12L4 12"
        stroke="#dedede"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  soundIcon: (
    <svg
      data-bbox="29.5 49.5 141 101"
      viewBox="0 0 200 200"
      height="200"
      width="200"
      xmlns="http://www.w3.org/2000/svg"
      data-type="shape"
    >
      <g>
        <path d="M95.09 50.352a4.03 4.03 0 0 0-4.231.477L58.7 76.291H33.5c-2.209 0-4 1.773-4 3.961v39.496c0 2.187 1.791 3.961 4 3.961h25.2l32.158 25.463a4.026 4.026 0 0 0 4.231.476 3.959 3.959 0 0 0 2.267-3.57V53.922c0-1.522-.88-2.91-2.266-3.57zm-5.734 87.487L62.6 116.654a4.02 4.02 0 0 0-2.498-.867H37.5V84.213h22.603c.908 0 1.789-.306 2.498-.867l26.756-21.185v75.678zM170.5 100c0 18.637-7.331 36.16-20.645 49.341-.781.773-1.805 1.159-2.828 1.159s-2.048-.387-2.829-1.16a3.933 3.933 0 0 1 .001-5.602C156.001 132.054 162.5 116.521 162.5 100s-6.499-32.054-18.301-43.738a3.935 3.935 0 0 1-.001-5.602 4.03 4.03 0 0 1 5.657-.001C163.169 63.84 170.5 81.363 170.5 100zm-44.121-26.104c7.034 6.964 10.908 16.223 10.908 26.071s-3.874 19.107-10.908 26.071c-.781.773-1.805 1.159-2.828 1.159s-2.048-.387-2.829-1.16a3.933 3.933 0 0 1 .001-5.602c5.522-5.467 8.564-12.736 8.564-20.468s-3.042-15.001-8.564-20.468a3.935 3.935 0 0 1-.001-5.602 4.03 4.03 0 0 1 5.657-.001z"></path>
      </g>
    </svg>
  ),
  binocular: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.5312 11.8647C18.4791 11.719 18.4177 11.5768 18.3477 11.4389L15.0984 4.04669C15.0677 3.9755 15.0237 3.9108 14.9688 3.85607C14.7366 3.62386 14.461 3.43966 14.1576 3.31399C13.8543 3.18832 13.5291 3.12363 13.2008 3.12363C12.8724 3.12363 12.5473 3.18832 12.2439 3.31399C11.9406 3.43966 11.665 3.62386 11.4328 3.85607C11.316 3.973 11.2503 4.13142 11.25 4.29669V6.24982H8.75V4.29669C8.75007 4.21459 8.73395 4.13328 8.70259 4.05741C8.67122 3.98154 8.62521 3.91259 8.56719 3.85451C8.33503 3.6223 8.05941 3.4381 7.75606 3.31243C7.45271 3.18675 7.12757 3.12207 6.79922 3.12207C6.47087 3.12207 6.14573 3.18675 5.84238 3.31243C5.53903 3.4381 5.2634 3.6223 5.03125 3.85451C4.97631 3.90924 4.9323 3.97393 4.90156 4.04513L1.65234 11.4373C1.58226 11.5752 1.52094 11.7175 1.46875 11.8631C1.28477 12.3779 1.21556 12.9267 1.26599 13.471C1.31641 14.0154 1.48524 14.5421 1.76066 15.0144C2.03608 15.4866 2.41141 15.8929 2.86038 16.2048C3.30934 16.5168 3.82107 16.7267 4.35973 16.8201C4.89839 16.9134 5.45094 16.8879 5.97867 16.7452C6.50641 16.6025 6.99657 16.3462 7.41482 15.9941C7.83307 15.6421 8.16929 15.2029 8.39993 14.7072C8.63057 14.2116 8.75005 13.6715 8.75 13.1248V7.49982H11.25V13.1248C11.2497 13.6716 11.369 14.2118 11.5995 14.7076C11.83 15.2033 12.1661 15.6427 12.5843 15.995C13.0025 16.3472 13.4926 16.6037 14.0204 16.7465C14.5481 16.8893 15.1008 16.915 15.6395 16.8218C16.1782 16.7285 16.6901 16.5186 17.1391 16.2067C17.5882 15.8949 17.9636 15.4885 18.2391 15.0163C18.5146 14.544 18.6835 14.0172 18.734 13.4728C18.7845 12.9284 18.7153 12.3795 18.5312 11.8647ZM5.99297 4.66779C6.20134 4.49234 6.46133 4.38975 6.73337 4.37565C7.0054 4.36155 7.2746 4.4367 7.5 4.58966V10.3326C7.01203 9.89447 6.41748 9.59223 5.77592 9.45622C5.13436 9.3202 4.46832 9.35517 3.84453 9.55763L5.99297 4.66779ZM5 15.6248C4.50555 15.6248 4.0222 15.4782 3.61107 15.2035C3.19995 14.9288 2.87952 14.5383 2.6903 14.0815C2.50108 13.6247 2.45157 13.122 2.54804 12.6371C2.6445 12.1521 2.8826 11.7067 3.23223 11.3571C3.58186 11.0074 4.02732 10.7693 4.51227 10.6729C4.99723 10.5764 5.49989 10.6259 5.95671 10.8151C6.41352 11.0043 6.80397 11.3248 7.07867 11.7359C7.35338 12.147 7.5 12.6304 7.5 13.1248C7.5 13.7879 7.23661 14.4237 6.76777 14.8926C6.29893 15.3614 5.66304 15.6248 5 15.6248ZM12.5 4.58888C12.7254 4.43592 12.9946 4.36077 13.2666 4.37487C13.5387 4.38897 13.7987 4.49155 14.007 4.66701L16.1555 9.55607C15.5316 9.35371 14.8655 9.31886 14.224 9.45502C13.5824 9.59118 12.9879 9.89355 12.5 10.3318V4.58888ZM15 15.6248C14.5055 15.6248 14.0222 15.4782 13.6111 15.2035C13.2 14.9288 12.8795 14.5383 12.6903 14.0815C12.5011 13.6247 12.4516 13.122 12.548 12.6371C12.6445 12.1521 12.8826 11.7067 13.2322 11.3571C13.5819 11.0074 14.0273 10.7693 14.5123 10.6729C14.9972 10.5764 15.4999 10.6259 15.9567 10.8151C16.4135 11.0043 16.804 11.3248 17.0787 11.7359C17.3534 12.147 17.5 12.6304 17.5 13.1248C17.5 13.7879 17.2366 14.4237 16.7678 14.8926C16.2989 15.3614 15.663 15.6248 15 15.6248Z"
        fill="black"
      />
    </svg>
  ),
  expiredClock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#ED1B24" strokeWidth="1.5" />
      <path
        d="M11.992 15H12.001"
        stroke="#ED1B24"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L12 8"
        stroke="#ED1B24"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  clock: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="#f77f00" strokeWidth="1.5" />
      <path
        d="M12 8V12L14 14"
        stroke="#f77f00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  cubeFocus: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 12.2992V7.70078C15.0004 7.52335 14.9543 7.34892 14.8663 7.19485C14.7783 7.04079 14.6515 6.91246 14.4984 6.82266L10.4875 4.50625C10.3393 4.42068 10.1711 4.37562 10 4.37562C9.82885 4.37562 9.66072 4.42068 9.5125 4.50625L5.50234 6.82266C5.34918 6.91236 5.2222 7.04065 5.13406 7.19472C5.04592 7.34879 4.99969 7.52328 5 7.70078V12.2992C4.99961 12.4766 5.04572 12.6511 5.13372 12.8051C5.22172 12.9592 5.34854 13.0875 5.50156 13.1773L9.5125 15.4938C9.66074 15.5792 9.82887 15.6243 10 15.6243C10.1711 15.6243 10.3393 15.5792 10.4875 15.4938L14.4977 13.1773C14.6508 13.0876 14.7778 12.9594 14.8659 12.8053C14.9541 12.6512 15.0003 12.4767 15 12.2992ZM10 5.66797L13.1711 7.5L10 9.33047L6.82891 7.5L10 5.66797ZM6.25 8.60859L9.375 10.4133V13.9711L6.25 12.1664V8.60859ZM10.625 13.9711V10.4133L13.75 8.60859V12.1664L10.625 13.9711ZM18.125 3.75V6.875C18.125 7.04076 18.0592 7.19973 17.9419 7.31694C17.8247 7.43415 17.6658 7.5 17.5 7.5C17.3342 7.5 17.1753 7.43415 17.0581 7.31694C16.9408 7.19973 16.875 7.04076 16.875 6.875V4.375H14.375C14.2092 4.375 14.0503 4.30915 13.9331 4.19194C13.8158 4.07473 13.75 3.91576 13.75 3.75C13.75 3.58424 13.8158 3.42527 13.9331 3.30806C14.0503 3.19085 14.2092 3.125 14.375 3.125H17.5C17.6658 3.125 17.8247 3.19085 17.9419 3.30806C18.0592 3.42527 18.125 3.58424 18.125 3.75ZM6.25 16.25C6.25 16.4158 6.18415 16.5747 6.06694 16.6919C5.94973 16.8092 5.79076 16.875 5.625 16.875H2.5C2.33424 16.875 2.17527 16.8092 2.05806 16.6919C1.94085 16.5747 1.875 16.4158 1.875 16.25V13.125C1.875 12.9592 1.94085 12.8003 2.05806 12.6831C2.17527 12.5658 2.33424 12.5 2.5 12.5C2.66576 12.5 2.82473 12.5658 2.94194 12.6831C3.05915 12.8003 3.125 12.9592 3.125 13.125V15.625H5.625C5.79076 15.625 5.94973 15.6908 6.06694 15.8081C6.18415 15.9253 6.25 16.0842 6.25 16.25ZM18.125 13.125V16.25C18.125 16.4158 18.0592 16.5747 17.9419 16.6919C17.8247 16.8092 17.6658 16.875 17.5 16.875H14.375C14.2092 16.875 14.0503 16.8092 13.9331 16.6919C13.8158 16.5747 13.75 16.4158 13.75 16.25C13.75 16.0842 13.8158 15.9253 13.9331 15.8081C14.0503 15.6908 14.2092 15.625 14.375 15.625H16.875V13.125C16.875 12.9592 16.9408 12.8003 17.0581 12.6831C17.1753 12.5658 17.3342 12.5 17.5 12.5C17.6658 12.5 17.8247 12.5658 17.9419 12.6831C18.0592 12.8003 18.125 12.9592 18.125 13.125ZM1.875 6.875V3.75C1.875 3.58424 1.94085 3.42527 2.05806 3.30806C2.17527 3.19085 2.33424 3.125 2.5 3.125H5.625C5.79076 3.125 5.94973 3.19085 6.06694 3.30806C6.18415 3.42527 6.25 3.58424 6.25 3.75C6.25 3.91576 6.18415 4.07473 6.06694 4.19194C5.94973 4.30915 5.79076 4.375 5.625 4.375H3.125V6.875C3.125 7.04076 3.05915 7.19973 2.94194 7.31694C2.82473 7.43415 2.66576 7.5 2.5 7.5C2.33424 7.5 2.17527 7.43415 2.05806 7.31694C1.94085 7.19973 1.875 7.04076 1.875 6.875Z"
        fill="black"
      />
    </svg>
  ),
  diamond: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.2193 7.71328L14.8443 2.71328C14.7858 2.64647 14.7137 2.59289 14.6329 2.55612C14.5521 2.51934 14.4643 2.50021 14.3755 2.5H5.62555C5.53675 2.50021 5.44901 2.51934 5.36818 2.55612C5.28735 2.59289 5.21529 2.64647 5.1568 2.71328L0.781795 7.71328C0.679731 7.82981 0.624578 7.98009 0.627032 8.13498C0.629486 8.28987 0.689372 8.43832 0.795077 8.55156L9.54508 17.9266C9.60356 17.9893 9.67431 18.0392 9.75293 18.0734C9.83156 18.1076 9.91638 18.1252 10.0021 18.1252C10.0878 18.1252 10.1727 18.1076 10.2513 18.0734C10.3299 18.0392 10.4007 17.9893 10.4591 17.9266L19.2091 8.55156C19.3144 8.43793 19.3737 8.28926 19.3756 8.13438C19.3775 7.97949 19.3218 7.82943 19.2193 7.71328ZM17.3732 7.5H14.063L11.2505 3.75H14.092L17.3732 7.5ZM5.82711 8.75L8.18101 14.6352L2.68883 8.75H5.82711ZM12.8271 8.75L10.0005 15.8172L7.17398 8.75H12.8271ZM7.50055 7.5L10.0005 4.16641L12.5005 7.5H7.50055ZM14.174 8.75H17.3123L11.8201 14.6352L14.174 8.75ZM5.90914 3.75H8.75055L5.93805 7.5H2.62789L5.90914 3.75Z"
        fill="#121418"
      />
    </svg>
  ),
  web: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3281 2.64062C8.72116 2.64063 7.15027 3.11715 5.81412 4.00993C4.47797 4.90272 3.43657 6.17167 2.82161 7.65632C2.20665 9.14097 2.04574 10.7746 2.35925 12.3507C2.67275 13.9268 3.44658 15.3746 4.58289 16.5109C5.71919 17.6472 7.16692 18.421 8.74302 18.7345C10.3191 19.048 11.9528 18.8871 13.4374 18.2721C14.9221 17.6572 16.191 16.6158 17.0838 15.2796C17.9766 13.9435 18.4531 12.3726 18.4531 10.7656C18.4509 8.61144 17.5941 6.54613 16.0709 5.02289C14.5476 3.49965 12.4823 2.6429 10.3281 2.64062ZM17.1758 10.1547C16.9768 10.1453 16.7776 10.1406 16.5781 10.1406C15.4188 10.141 14.2645 10.2944 13.1453 10.5969C12.8725 9.78717 12.5205 9.00632 12.0945 8.26562C13.2055 7.59572 14.2111 6.76511 15.0789 5.80078C16.283 6.94958 17.0283 8.49703 17.1758 10.1547ZM14.1 5.02031C13.3193 5.87811 12.417 6.61671 11.4219 7.2125C10.5884 6.03939 9.56902 5.01023 8.40391 4.16563C9.35971 3.8866 10.3647 3.81852 11.3494 3.96609C12.3341 4.11366 13.275 4.47336 14.107 5.02031H14.1ZM7.01954 4.74063C8.29656 5.54484 9.40989 6.58342 10.3008 7.80156C8.74159 8.52019 7.04497 8.89177 5.32813 8.89062C4.79826 8.89035 4.26898 8.85512 3.74375 8.78516C4.26638 7.06133 5.44189 5.60995 7.01954 4.74063ZM3.45313 10.7656C3.4531 10.514 3.46692 10.2626 3.49453 10.0125C4.10201 10.0978 4.71469 10.1406 5.32813 10.1406C7.28871 10.1425 9.22475 9.70465 10.9938 8.85938C11.3835 9.53241 11.7056 10.2424 11.9555 10.9789C11.2916 11.2283 10.6491 11.5314 10.0344 11.8852C8.31959 12.8758 6.84927 14.2391 5.73203 15.8742C5.01458 15.2306 4.44083 14.443 4.04817 13.5628C3.6555 12.6826 3.45275 11.7295 3.45313 10.7656ZM6.73438 16.625C7.74872 15.1248 9.09088 13.8748 10.6594 12.9695C11.1838 12.6669 11.731 12.4057 12.2961 12.1883C12.4895 13.0465 12.5872 13.9234 12.5875 14.8031C12.5879 15.6584 12.4965 16.5112 12.3148 17.3469C11.3864 17.6273 10.4091 17.708 9.4473 17.5836C8.48546 17.4592 7.56087 17.1325 6.73438 16.625ZM13.6922 16.7602C13.7886 16.1136 13.8372 15.4608 13.8375 14.807C13.8374 13.7952 13.7207 12.7867 13.4898 11.8016C14.4968 11.5298 15.5351 11.3917 16.5781 11.3906C16.776 11.3906 16.9742 11.3956 17.1727 11.4055C17.068 12.5126 16.6968 13.5779 16.0906 14.5103C15.4845 15.4427 14.6616 16.2144 13.6922 16.7594V16.7602Z"
        fill="white"
      />
    </svg>
  ),
  messenger: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9578 9.07303C15.0159 9.13108 15.062 9.20001 15.0935 9.27588C15.1249 9.35176 15.1411 9.43309 15.1411 9.51522C15.1411 9.59736 15.1249 9.67869 15.0935 9.75456C15.062 9.83043 15.0159 9.89936 14.9578 9.95741L12.4578 12.4574C12.3998 12.5155 12.3308 12.5616 12.255 12.5931C12.1791 12.6245 12.0978 12.6407 12.0156 12.6407C11.9335 12.6407 11.8522 12.6245 11.7763 12.5931C11.7004 12.5616 11.6315 12.5155 11.5734 12.4574L9.51562 10.3988L7.45781 12.4574C7.34054 12.5747 7.18148 12.6406 7.01562 12.6406C6.84977 12.6406 6.69071 12.5747 6.57344 12.4574C6.45616 12.3401 6.39028 12.1811 6.39028 12.0152C6.39028 11.8494 6.45616 11.6903 6.57344 11.573L9.07344 9.07303C9.13148 9.01492 9.20041 8.96883 9.27629 8.93737C9.35216 8.90592 9.43349 8.88973 9.51562 8.88973C9.59776 8.88973 9.67909 8.90592 9.75496 8.93737C9.83084 8.96883 9.89977 9.01492 9.95781 9.07303L12.0156 11.1316L14.0734 9.07303C14.1315 9.01492 14.2004 8.96883 14.2763 8.93737C14.3522 8.90592 14.4335 8.88973 14.5156 8.88973C14.5978 8.88973 14.6791 8.90592 14.755 8.93737C14.8308 8.96883 14.8998 9.01492 14.9578 9.07303ZM18.8906 10.7652C18.8909 12.168 18.5281 13.5469 17.8373 14.7678C17.1466 15.9887 16.1515 17.01 14.949 17.7323C13.7464 18.4545 12.3774 18.8531 10.9751 18.8893C9.57282 18.9255 8.18504 18.598 6.94688 17.9387L4.28672 18.8254C4.06647 18.8988 3.83012 18.9095 3.60416 18.8562C3.3782 18.8028 3.17155 18.6876 3.00738 18.5235C2.84321 18.3593 2.72801 18.1526 2.67469 17.9267C2.62136 17.7007 2.63202 17.4644 2.70547 17.2441L3.59219 14.584C3.01262 13.4943 2.6889 12.2869 2.64562 11.0535C2.60234 9.82003 2.84063 8.59293 3.3424 7.46533C3.84417 6.33772 4.59623 5.33924 5.5415 4.54568C6.48677 3.75213 7.6004 3.18434 8.79787 2.88544C9.99533 2.58653 11.2452 2.56435 12.4525 2.82059C13.6598 3.07682 14.7929 3.60474 15.7657 4.36426C16.7385 5.12378 17.5255 6.09495 18.067 7.20405C18.6084 8.31314 18.8901 9.53101 18.8906 10.7652ZM17.6406 10.7652C17.6403 9.71063 17.3974 8.67024 16.9307 7.72455C16.464 6.77886 15.7859 5.95322 14.9491 5.3115C14.1122 4.66978 13.1389 4.22918 12.1045 4.02381C11.0701 3.81843 10.0023 3.85377 8.98378 4.1271C7.96522 4.40042 7.0232 4.90441 6.23059 5.60006C5.43798 6.29571 4.81603 7.16438 4.41286 8.13886C4.00969 9.11335 3.83611 10.1675 3.90554 11.2198C3.97498 12.2721 4.28557 13.2943 4.81328 14.2074C4.85757 14.2841 4.88507 14.3693 4.89396 14.4573C4.90285 14.5454 4.89293 14.6344 4.86484 14.7183L3.89062 17.6402L6.8125 16.6652C6.89651 16.6373 6.98551 16.6275 7.07359 16.6365C7.16168 16.6455 7.24684 16.6731 7.32344 16.7176C8.36857 17.3221 9.55448 17.6407 10.7618 17.6413C11.9692 17.642 13.1555 17.3247 14.2013 16.7213C15.2471 16.118 16.1155 15.2499 16.7193 14.2043C17.3231 13.1587 17.6408 11.9726 17.6406 10.7652Z"
        fill="white"
      />
    </svg>
  ),
  offersIcon: (
    <svg
      width="256px"
      height="256px"
      viewBox="-2.5 -2.5 30.00 30.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0">
        <path
          transform="translate(-2.5, -2.5), scale(1.875)"
          fill="#DD1D1D"
          d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
          strokeWidth="0"
        ></path>
      </g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.817 16.063V14.721C17.817 14.3887 17.949 14.07 18.184 13.835L19.133 12.886C19.6223 12.3967 19.6223 11.6033 19.133 11.114L18.184 10.165C17.949 9.93001 17.817 9.61131 17.817 9.27899V7.93599C17.817 7.24398 17.256 6.68299 16.564 6.68299H15.221C14.8887 6.68299 14.57 6.55097 14.335 6.31599L13.386 5.36699C12.8967 4.87767 12.1033 4.87767 11.614 5.36699L10.665 6.31599C10.43 6.55097 10.1113 6.68299 9.77899 6.68299H8.43599C8.1035 6.68299 7.78464 6.81514 7.54963 7.05034C7.31462 7.28554 7.18273 7.6045 7.18299 7.93699V9.27899C7.18299 9.61131 7.05097 9.93001 6.81599 10.165L5.86699 11.114C5.37767 11.6033 5.37767 12.3967 5.86699 12.886L6.81599 13.835C7.05097 14.07 7.18299 14.3887 7.18299 14.721V16.063C7.18299 16.755 7.74398 17.316 8.43599 17.316H9.77899C10.1113 17.316 10.43 17.448 10.665 17.683L11.614 18.632C12.1033 19.1213 12.8967 19.1213 13.386 18.632L14.335 17.683C14.57 17.448 14.8887 17.316 15.221 17.316H16.563C16.8955 17.3163 17.2144 17.1844 17.4496 16.9493C17.6848 16.7143 17.817 16.3955 17.817 16.063Z"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>{' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.78202 10.641C9.50715 10.3662 9.42492 9.95286 9.57366 9.59375C9.7224 9.23464 10.0728 9.00049 10.4615 9.00049C10.8502 9.00049 11.2006 9.23464 11.3494 9.59375C11.4981 9.95286 11.4159 10.3662 11.141 10.641C10.7657 11.0163 10.1573 11.0163 9.78202 10.641Z"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>{' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.859 14.718C13.5841 14.4431 13.5019 14.0298 13.6506 13.6707C13.7994 13.3115 14.1498 13.0774 14.5385 13.0774C14.9272 13.0774 15.2776 13.3115 15.4263 13.6707C15.5751 14.0298 15.4928 14.4431 15.218 14.718C14.8427 15.0932 14.2343 15.0932 13.859 14.718Z"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          fill="none"
        ></path>{' '}
        <path
          d="M15.218 9.28101L9.78101 14.719"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          fill="none"
        ></path>{' '}
      </g>
    </svg>
  ),
  tabRibbon: (
    <svg
      width="800"
      height="780"
      viewBox="0 0 800 780"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.24"
        d="M310.539 676.953C301.636 670.931 290.795 667.378 279.269 667.392C271.58 667.392 264.177 668.954 257.483 671.798C247.43 676.05 238.928 683.117 232.894 692.045C226.86 700.948 223.319 711.789 223.344 723.314C223.331 730.989 224.895 738.393 227.738 745.086C232 755.153 239.056 763.654 247.972 769.675C256.888 775.723 267.741 779.25 279.267 779.25C286.942 779.25 294.335 777.686 301.027 774.843C311.092 770.592 319.594 763.511 325.63 754.597C331.652 745.693 335.192 734.839 335.192 723.312C335.192 715.639 333.616 708.247 330.786 701.54C326.524 691.476 319.455 682.975 310.539 676.953ZM300.047 732.089C298.341 736.12 295.46 739.597 291.855 742.025C288.236 744.454 283.999 745.862 279.269 745.875C276.103 745.862 273.171 745.242 270.496 744.09C266.477 742.412 262.988 739.517 260.558 735.925C258.128 732.293 256.72 728.043 256.708 723.312C256.722 720.159 257.353 717.239 258.478 714.539C260.17 710.52 263.066 707.045 266.669 704.604C270.288 702.175 274.539 700.779 279.269 700.765C282.422 700.765 285.342 701.4 288.03 702.536C292.061 704.228 295.524 707.109 297.953 710.728C300.396 714.345 301.803 718.584 301.803 723.312C301.803 726.481 301.172 729.401 300.047 732.089Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M338.321 433.076C349.692 429.768 356.23 417.842 352.896 406.457L297.308 216.151C294 204.767 282.086 198.242 270.702 201.562C259.319 204.884 252.806 216.797 256.114 228.168L311.702 418.5C315.035 429.872 326.949 436.409 338.321 433.076Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M401.531 404.339C404.866 415.723 416.78 422.248 428.149 418.926C439.521 415.606 446.06 403.693 442.725 392.309L391.169 215.79C387.861 204.407 375.947 197.881 364.564 201.19C353.18 204.523 346.655 216.437 349.975 227.807L401.531 404.339Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M491.491 390.603C494.811 401.987 506.738 408.512 518.108 405.192C529.48 401.87 536.017 389.943 532.683 378.573L485.042 215.429C481.721 204.045 469.808 197.52 458.436 200.854C447.053 204.162 440.527 216.089 443.849 227.459L491.491 390.603Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M581.164 375.951C584.499 387.336 596.411 393.861 607.781 390.539C619.153 387.206 625.691 375.306 622.37 363.922L578.889 215.054C575.581 203.672 563.655 197.159 552.271 200.467C540.9 203.801 534.375 215.714 537.696 227.084L581.164 375.951Z"
        fill="black"
      />
      <path
        opacity="0.24"
        d="M263.635 603.445C257.586 603.445 251.928 602.229 246.733 600.045C238.967 596.764 232.286 591.233 227.61 584.281C223.113 577.6 220.45 569.731 220.244 561.1C220.475 550.8 223.758 541.861 229.521 534.714C232.505 531.031 236.188 527.801 240.658 525.126C245.077 522.49 250.285 520.397 256.397 519.079L638.17 456.94C663.11 452.87 682.956 433.8 687.995 409.028L734.694 179.453V179.428C735.236 176.765 735.496 174.053 735.496 171.365C735.496 162.087 732.316 153.017 726.347 145.703C718.644 136.297 707.119 130.831 694.96 130.831H166.335L148.325 68.9528V68.9653C140.055 41.3012 117.366 20.3434 89.1455 14.2965L24.5127 0.455903C13.5799 -1.89566 2.8049 5.08246 0.451773 16.0262C-1.88573 26.97 5.07677 37.7465 16.0361 40.0856L80.6424 53.9372C94.3893 56.8825 105.452 67.0903 109.483 80.5809L227.583 486.259C224.922 487.5 222.35 488.843 219.869 490.329C207.141 497.915 196.933 508.562 190.086 520.992C183.533 532.801 180.058 546.189 179.724 560.001H179.672V562.107H179.724C179.981 572.898 182.281 583.247 186.274 592.693C192.671 607.798 203.291 620.578 216.677 629.622C230.052 638.678 246.319 643.99 263.633 643.976H478.121C478.055 641.975 477.817 640.023 477.817 638.007C477.817 626.184 479.038 614.645 481.214 603.443H263.635V603.445ZM178.122 171.367H694.963H694.977L648.278 400.953C646.597 409.223 639.981 415.581 631.661 416.925L266.891 476.311L178.122 171.367Z"
        fill="black"
      />
      <path
        d="M658.756 496.765C580.75 496.765 517.513 560.003 517.513 638.009C517.513 716.015 580.75 779.253 658.756 779.253C736.775 779.253 800 716.015 800 638.009C800 560.003 736.775 496.765 658.756 496.765Z"
        fill="#dd1d1d"
      />
      <path
        d="M694.484 638.539L734.099 597.31L700.147 564.687L660.532 605.917L619.302 566.301L586.687 600.245L627.918 639.861L588.302 681.091L622.254 713.713L661.869 672.483L703.09 712.089L735.704 678.145L694.484 638.539Z"
        fill="white"
      />
    </svg>
  ),
  offersIcon: (
    <svg
      width="256px"
      height="256px"
      viewBox="-2.5 -2.5 30.00 30.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0">
        <path
          transform="translate(-2.5, -2.5), scale(1.875)"
          fill="#DD1D1D"
          d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
          strokeWidth="0"
        ></path>
      </g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.817 16.063V14.721C17.817 14.3887 17.949 14.07 18.184 13.835L19.133 12.886C19.6223 12.3967 19.6223 11.6033 19.133 11.114L18.184 10.165C17.949 9.93001 17.817 9.61131 17.817 9.27899V7.93599C17.817 7.24398 17.256 6.68299 16.564 6.68299H15.221C14.8887 6.68299 14.57 6.55097 14.335 6.31599L13.386 5.36699C12.8967 4.87767 12.1033 4.87767 11.614 5.36699L10.665 6.31599C10.43 6.55097 10.1113 6.68299 9.77899 6.68299H8.43599C8.1035 6.68299 7.78464 6.81514 7.54963 7.05034C7.31462 7.28554 7.18273 7.6045 7.18299 7.93699V9.27899C7.18299 9.61131 7.05097 9.93001 6.81599 10.165L5.86699 11.114C5.37767 11.6033 5.37767 12.3967 5.86699 12.886L6.81599 13.835C7.05097 14.07 7.18299 14.3887 7.18299 14.721V16.063C7.18299 16.755 7.74398 17.316 8.43599 17.316H9.77899C10.1113 17.316 10.43 17.448 10.665 17.683L11.614 18.632C12.1033 19.1213 12.8967 19.1213 13.386 18.632L14.335 17.683C14.57 17.448 14.8887 17.316 15.221 17.316H16.563C16.8955 17.3163 17.2144 17.1844 17.4496 16.9493C17.6848 16.7143 17.817 16.3955 17.817 16.063Z"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>{' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.78202 10.641C9.50715 10.3662 9.42492 9.95286 9.57366 9.59375C9.7224 9.23464 10.0728 9.00049 10.4615 9.00049C10.8502 9.00049 11.2006 9.23464 11.3494 9.59375C11.4981 9.95286 11.4159 10.3662 11.141 10.641C10.7657 11.0163 10.1573 11.0163 9.78202 10.641Z"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>{' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.859 14.718C13.5841 14.4431 13.5019 14.0298 13.6506 13.6707C13.7994 13.3115 14.1498 13.0774 14.5385 13.0774C14.9272 13.0774 15.2776 13.3115 15.4263 13.6707C15.5751 14.0298 15.4928 14.4431 15.218 14.718C14.8427 15.0932 14.2343 15.0932 13.859 14.718Z"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          fill="none"
        ></path>{' '}
        <path
          d="M15.218 9.28101L9.78101 14.719"
          stroke="#ffffff"
          strokeWidth="0.7249999999999999"
          strokeLinecap="round"
          fill="none"
        ></path>{' '}
      </g>
    </svg>
  ),

  tiktok: (
    <svg
      width="21"
      height="21"
      fill="#000000"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  question: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M11.5801 14.7148C11.5801 14.9003 11.5251 15.0815 11.4221 15.2357C11.3191 15.3899 11.1727 15.51 11.0013 15.581C10.83 15.6519 10.6415 15.6705 10.4597 15.6343C10.2778 15.5982 10.1108 15.5089 9.97967 15.3778C9.84856 15.2466 9.75927 15.0796 9.7231 14.8977C9.68692 14.7159 9.70549 14.5274 9.77644 14.3561C9.8474 14.1848 9.96756 14.0384 10.1217 13.9353C10.2759 13.8323 10.4572 13.7773 10.6426 13.7773C10.8912 13.7773 11.1297 13.8761 11.3055 14.0519C11.4813 14.2277 11.5801 14.4662 11.5801 14.7148ZM10.6426 6.27734C8.91914 6.27734 7.51758 7.53906 7.51758 9.08984V9.40234C7.51758 9.5681 7.58343 9.72708 7.70064 9.84429C7.81785 9.9615 7.97682 10.0273 8.14258 10.0273C8.30834 10.0273 8.46731 9.9615 8.58452 9.84429C8.70173 9.72708 8.76758 9.5681 8.76758 9.40234V9.08984C8.76758 8.23047 9.60899 7.52734 10.6426 7.52734C11.6762 7.52734 12.5176 8.23047 12.5176 9.08984C12.5176 9.94922 11.6762 10.6523 10.6426 10.6523C10.4768 10.6523 10.3179 10.7182 10.2006 10.8354C10.0834 10.9526 10.0176 11.1116 10.0176 11.2773V11.9023C10.0176 12.0681 10.0834 12.2271 10.2006 12.3443C10.3179 12.4615 10.4768 12.5273 10.6426 12.5273C10.8083 12.5273 10.9673 12.4615 11.0845 12.3443C11.2017 12.2271 11.2676 12.0681 11.2676 11.9023V11.8461C12.6926 11.5844 13.7676 10.4477 13.7676 9.08984C13.7676 7.53906 12.366 6.27734 10.6426 6.27734ZM18.7676 10.6523C18.7676 12.2593 18.2911 13.8302 17.3983 15.1664C16.5055 16.5025 15.2365 17.5439 13.7519 18.1589C12.2672 18.7738 10.6336 18.9347 9.05747 18.6212C7.48138 18.3077 6.03364 17.5339 4.89734 16.3976C3.76104 15.2613 2.98721 13.8135 2.6737 12.2375C2.3602 10.6614 2.5211 9.02769 3.13606 7.54304C3.75102 6.05839 4.79242 4.78944 6.12857 3.89665C7.46472 3.00387 9.03561 2.52734 10.6426 2.52734C12.7968 2.52962 14.8621 3.38637 16.3853 4.90961C17.9086 6.43285 18.7653 8.49816 18.7676 10.6523ZM17.5176 10.6523C17.5176 9.2926 17.1144 7.96339 16.3589 6.8328C15.6035 5.70221 14.5298 4.82102 13.2735 4.30067C12.0173 3.78032 10.635 3.64417 9.30134 3.90944C7.96772 4.17472 6.74271 4.8295 5.78122 5.79098C4.81974 6.75247 4.16496 7.97748 3.89968 9.3111C3.63441 10.6447 3.77056 12.0271 4.29091 13.2833C4.81126 14.5395 5.69245 15.6133 6.82304 16.3687C7.95362 17.1241 9.28284 17.5273 10.6426 17.5273C12.4653 17.5253 14.2128 16.8003 15.5017 15.5114C16.7905 14.2226 17.5155 12.4751 17.5176 10.6523Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  whiteLogo: (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1949 1.78699L12.1964 1.78269L12.1269 1.82278L12.1949 1.78699ZM8.8218 1.89077L2.55713 12.7398L2.77931 12.5291L3.03959 12.2995L3.30928 12.075L3.58365 11.859L3.86796 11.6495L4.16199 11.451L4.45116 11.2645L4.75068 11.0834L5.05934 10.9107L5.37166 10.7494L5.68547 10.6035L6.00475 10.4584L6.33015 10.3265L6.65894 10.2052L6.99196 10.0942L7.32753 9.99349L7.66318 9.90301L8.00276 9.82251L8.34332 9.75527L8.6841 9.69701L9.0291 9.64732L9.37539 9.61079L9.72075 9.58298L10.069 9.56976H10.7606L11.1102 9.58298L11.4556 9.61079L11.8019 9.64732L12.1469 9.69701L12.488 9.75532L12.8314 9.824L12.9622 9.85502L12.9953 9.72939L13.0727 9.39988L13.1402 9.07097L13.1977 8.73825L13.244 8.40478L13.2777 8.07159L13.3045 7.73319L13.3213 7.39926V6.7234L13.3059 6.38808L13.2792 6.05195L13.2441 5.7164L13.1965 5.3858L13.1374 5.05123L13.0699 4.72332L12.9925 4.39417L12.9056 4.06894L12.8061 3.74678L12.6963 3.42862L12.5796 3.11369L12.4509 2.8017L12.3103 2.49522L12.1624 2.18954L12.0036 1.88758L12.0065 1.88608C11.8452 1.6083 11.6139 1.37757 11.3357 1.21687C11.0559 1.05529 10.7386 0.970215 10.4155 0.970215C10.0924 0.970215 9.77507 1.05529 9.49531 1.21687C9.21556 1.37845 8.98323 1.61093 8.8218 1.89077ZM0.964814 15.0718L0.957652 15.069L0.986001 15.0854L0.964814 15.0718ZM14.9833 17.8568L15.2665 17.9418H2.74426L2.74357 17.9418C2.41962 17.9428 2.10113 17.8583 1.82026 17.6969C1.53939 17.5355 1.30608 17.3028 1.14388 17.0224C0.981686 16.742 0.896349 16.4237 0.896485 16.0998C0.896619 15.7785 0.980805 15.4629 1.14061 15.1843L1.14686 15.1883L1.32883 14.904L1.51872 14.6227L1.71478 14.3524L1.92423 14.0853L2.13844 13.8246L2.35873 13.572L2.58911 13.3262L2.82676 13.0857L3.07212 12.853L3.3219 12.6327L3.58231 12.4159L3.84665 12.2078L4.11823 12.0076L4.3992 11.818L4.68122 11.6361L4.9691 11.4619L5.26506 11.2964L5.56307 11.1425L5.8662 11.0015L6.17647 10.8605L6.4872 10.7345L6.80312 10.618L7.12344 10.5112L7.44692 10.4142L7.57191 10.3805L7.61092 10.5076L7.71968 10.8369L7.84245 11.1643L7.9722 11.4865L8.11142 11.803L8.26375 12.115L8.42216 12.4245L8.59211 12.7278L8.76914 13.0204L8.95729 13.3099L9.15168 13.6022L9.35715 13.884L9.57213 14.1589L9.79382 14.4244L10.0232 14.6859L10.2611 14.9368L10.5095 15.1882L10.7635 15.4248L11.0264 15.6599L11.2956 15.8823L11.5731 16.0984L11.576 16.1006L11.857 16.3048L12.1466 16.5003L12.44 16.6896L12.743 16.8711L13.0459 17.0378L13.3601 17.2015L13.6758 17.347L13.9961 17.4926L14.3215 17.6245L14.6502 17.7458L14.9833 17.8568ZM19.6783 15.1778L19.6771 15.1785L13.4203 4.34924L13.4862 4.6294L13.5562 4.96918L13.6175 5.31656L13.6673 5.66221L13.7038 6.01149L13.7315 6.3602L13.7477 6.71262V7.40927L13.7301 7.76022L13.7022 8.11191L13.6674 8.45542L13.6191 8.80394L13.5591 9.15037L13.4891 9.49193L13.4089 9.83296L13.3197 10.1724L13.2167 10.5076L13.1093 10.8326L12.9866 11.16L12.8568 11.4822L12.7176 11.7987L12.5635 12.1143L12.4069 12.4202L12.2367 12.7238L12.0584 13.0161L11.8705 13.3075L11.6773 13.5979L11.4719 13.8797L11.2569 14.1546L11.035 14.4203L10.8048 14.6811L10.7134 14.7793L10.8067 14.8737L11.0525 15.1027L11.3042 15.3277L11.5621 15.5407L11.8291 15.7487L12.1011 15.9464L12.3826 16.1364L12.6643 16.3181L12.9544 16.4919L13.2482 16.6536L13.5465 16.809L13.8517 16.9496L13.8527 16.9501L14.1628 17.091L14.4735 17.217L14.7894 17.3335L15.1098 17.4403L15.4323 17.5371L15.7565 17.6213L16.0859 17.6973L16.4147 17.7633L16.7489 17.8195L17.0818 17.8645L17.416 17.8996L17.7517 17.9235L18.0877 17.9374C18.4093 17.9365 18.7251 17.8514 19.0036 17.6905C19.2834 17.5288 19.5157 17.2964 19.6772 17.0165C19.8387 16.7366 19.9237 16.4191 19.9237 16.096C19.9237 15.7737 19.839 15.4571 19.6783 15.1778Z"
        fill="white"
      />
    </svg>
  ),
  rightArrow: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.15209 9.10823L4.49468 8.4572L6.4637 6.48818H1.67997V5.53718H6.4637L4.49468 3.57135L5.15209 2.91714L8.24763 6.01268L5.15209 9.10823Z"
        fill="#121418"
      />
    </svg>
  ),
  rightSliderArrow: (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.3223 10.9013L5.20523 9.79505L8.55102 6.44927H0.422448V4.83332H8.55102L5.20523 1.49296L6.3223 0.381316L11.5823 5.6413L6.3223 10.9013Z"
        fill="#121418"
      />
    </svg>
  ),

  leftSliderArrow: (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.67867 10.9013L6.79574 9.79505L3.44996 6.44927H11.5785V4.83332H3.44996L6.79574 1.49296L5.67867 0.381316L0.418693 5.6413L5.67867 10.9013Z"
        fill="#121418"
      />
    </svg>
  ),
  rightAngle: (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.59375 1.41758L6.29414 6.11797L1.59375 10.8184"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  downAngle: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1L6.29289 6.29289C6.62623 6.62623 6.79289 6.79289 7 6.79289C7.20711 6.79289 7.37377 6.62623 7.70711 6.29289L13 1"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  upAngle: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7L6.29289 1.70711C6.62623 1.37377 6.79289 1.20711 7 1.20711C7.20711 1.20711 7.37377 1.37377 7.70711 1.70711L13 7"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  cart: (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.919922 1H2.30561C2.81529 1 3.2613 1.34265 3.39262 1.83513L3.77582 3.27209M6.16992 12.25C4.51307 12.25 3.16992 13.5931 3.16992 15.25H18.9199M6.16992 12.25H17.3882C18.5093 9.94936 19.4876 7.56635 20.3116 5.1125C15.55 3.89646 10.5604 3.25 5.41992 3.25C4.87013 3.25 4.32206 3.2574 3.77582 3.27209M6.16992 12.25L3.77582 3.27209M4.66992 18.25C4.66992 18.6642 4.33414 19 3.91992 19C3.50571 19 3.16992 18.6642 3.16992 18.25C3.16992 17.8358 3.50571 17.5 3.91992 17.5C4.33414 17.5 4.66992 17.8358 4.66992 18.25ZM17.4199 18.25C17.4199 18.6642 17.0841 19 16.6699 19C16.2557 19 15.9199 18.6642 15.9199 18.25C15.9199 17.8358 16.2557 17.5 16.6699 17.5C17.0841 17.5 17.4199 17.8358 17.4199 18.25Z"
        stroke="#89898A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  bell: (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1684 17.0817C14.0629 16.857 15.8898 16.4116 17.6227 15.7719C16.1859 14.177 15.3113 12.0656 15.3113 9.75V9.04919C15.3115 9.03281 15.3115 9.01641 15.3115 9C15.3115 5.68629 12.6252 3 9.31152 3C5.99781 3 3.31152 5.68629 3.31152 9L3.31133 9.75C3.31133 12.0656 2.4368 14.177 1 15.7719C2.73293 16.4116 4.55996 16.857 6.45466 17.0818M12.1684 17.0817C11.2315 17.1928 10.2781 17.25 9.31133 17.25C8.34469 17.25 7.3914 17.1929 6.45466 17.0818M12.1684 17.0817C12.2613 17.3711 12.3115 17.6797 12.3115 18C12.3115 19.6569 10.9684 21 9.31152 21C7.65467 21 6.31152 19.6569 6.31152 18C6.31152 17.6797 6.36171 17.3712 6.45466 17.0818"
        stroke="#89898A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="4.5" cy="4.5" r="3.93789" fill="#0055FF" stroke="white" strokeWidth="1.12422" />
    </svg>
  ),
  eyeOpen: (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.544 7.04498C20.848 7.4713 21 7.68447 21 8C21 8.31553 20.848 8.52869 20.544 8.95501C19.1779 10.8706 15.6892 15 11 15C6.31078 15 2.8221 10.8706 1.45604 8.95502C1.15201 8.5287 1 8.31553 1 8C1 7.68447 1.15201 7.47131 1.45604 7.04499C2.8221 5.12944 6.31078 1 11 1C15.6892 1 19.1779 5.12944 20.544 7.04498Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11C12.6569 11 14 9.65685 14 8Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  eyeClose: (
    <svg width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 1C21 1 17 7 11 7C5 7 1 1 1 1"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M14 6.5L15.5 9"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19 4L21 6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M1 6L3 4"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8 6.5L6.5 9"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  templates: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6699 9.37695H9.4812V14.5657H14.6699V9.37695Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.51623 9.37695H1.32751V14.5657H6.51623V9.37695Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.6699 1.22363H9.4812V6.41235H14.6699V1.22363Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.51623 1.22363H1.32751V6.41235H6.51623V1.22363Z"
        stroke="#121418"
        strokeWidth="1.11187"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  profile: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
        <path
          d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  addUser: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M20 18L17 18M17 18L14 18M17 18V15M17 18V21M11 21H4C4 17.134 7.13401 14 11 14C11.695 14 12.3663 14.1013 13 14.2899M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  addSocial: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M5 16V20M6 4V8M7 18H3M8 6H4M13 4L14.7528 8.44437C14.9407 8.92083 15.0347 9.15906 15.1786 9.35994C15.3061 9.538 15.462 9.69391 15.6401 9.82143C15.8409 9.9653 16.0792 10.0593 16.5556 10.2472L21 12L16.5556 13.7528C16.0792 13.9407 15.8409 14.0347 15.6401 14.1786C15.462 14.3061 15.3061 14.462 15.1786 14.6401C15.0347 14.8409 14.9407 15.0792 14.7528 15.5556L13 20L11.2472 15.5556C11.0593 15.0792 10.9653 14.8409 10.8214 14.6401C10.6939 14.462 10.538 14.3061 10.3599 14.1786C10.1591 14.0347 9.92083 13.9407 9.44437 13.7528L5 12L9.44437 10.2472C9.92083 10.0593 10.1591 9.9653 10.3599 9.82143C10.538 9.69391 10.6939 9.538 10.8214 9.35994C10.9653 9.15906 11.0593 8.92083 11.2472 8.44437L13 4Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  email: (
    <svg
      width="24"
      height="24"
      viewBox="0 -2.5 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            id="DribbbleLight-Preview"
            transform="translate(-340.000000, -922.000000)"
            fill="#000000"
          >
            <g id="icons" transform="translate(56.000000, 160.000000)">
              <path
                d="M294,774.474 L284,765.649 L284,777 L304,777 L304,765.649 L294,774.474 Z M294.001,771.812 L284,762.981 L284,762 L304,762 L304,762.981 L294.001,771.812 Z"
                id="email-[#1572]"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  keyboard: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M7 14H17M6 10H6.01M10 10H10.01M14 10H14.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  settings: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.49852 10.9497C10.6334 10.9497 11.5534 10.0297 11.5534 8.89476C11.5534 7.75986 10.6334 6.83984 9.49852 6.83984C8.36362 6.83984 7.4436 7.75986 7.4436 8.89476C7.4436 10.0297 8.36362 10.9497 9.49852 10.9497Z"
        stroke="#121418"
        strokeWidth="1.75141"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.8007 11.0445C14.7053 11.2606 14.6768 11.5003 14.719 11.7327C14.7611 11.9652 14.8719 12.1796 15.0371 12.3485L15.0801 12.3915C15.2133 12.5246 15.319 12.6826 15.3911 12.8566C15.4632 13.0305 15.5004 13.217 15.5004 13.4053C15.5004 13.5936 15.4632 13.7801 15.3911 13.954C15.319 14.128 15.2133 14.286 15.0801 14.4191C14.947 14.5524 14.789 14.6581 14.615 14.7302C14.441 14.8023 14.2546 14.8394 14.0663 14.8394C13.8779 14.8394 13.6915 14.8023 13.5175 14.7302C13.3436 14.6581 13.1855 14.5524 13.0524 14.4191L13.0094 14.3761C12.8406 14.211 12.6261 14.1002 12.3937 14.058C12.1613 14.0159 11.9215 14.0443 11.7054 14.1397C11.4935 14.2305 11.3128 14.3813 11.1855 14.5736C11.0582 14.7658 10.9899 14.991 10.9889 15.2216V15.3434C10.9889 15.7234 10.838 16.0879 10.5692 16.3567C10.3005 16.6254 9.93602 16.7764 9.55598 16.7764C9.17593 16.7764 8.81145 16.6254 8.54271 16.3567C8.27398 16.0879 8.123 15.7234 8.123 15.3434V15.2789C8.11746 15.0418 8.04069 14.8118 7.90269 14.6188C7.76469 14.4259 7.57184 14.2789 7.3492 14.197C7.1331 14.1016 6.89338 14.0732 6.66095 14.1153C6.42853 14.1575 6.21405 14.2683 6.04519 14.4335L6.0022 14.4764C5.86912 14.6097 5.71108 14.7154 5.53712 14.7875C5.36316 14.8596 5.17669 14.8967 4.98838 14.8967C4.80006 14.8967 4.61359 14.8596 4.43963 14.7875C4.26567 14.7154 4.10763 14.6097 3.97455 14.4764C3.84132 14.3434 3.73562 14.1853 3.66351 14.0114C3.5914 13.8374 3.55428 13.6509 3.55428 13.4626C3.55428 13.2743 3.5914 13.0878 3.66351 12.9139C3.73562 12.7399 3.84132 12.5819 3.97455 12.4488L4.01754 12.4058C4.18271 12.2369 4.29352 12.0225 4.33566 11.79C4.3778 11.5576 4.34935 11.3179 4.25398 11.1018C4.16315 10.8899 4.01235 10.7092 3.82012 10.5818C3.6279 10.4545 3.40264 10.3862 3.17208 10.3853H3.05028C2.67023 10.3853 2.30575 10.2343 2.03702 9.9656C1.76828 9.69687 1.61731 9.33239 1.61731 8.95234C1.61731 8.57229 1.76828 8.20781 2.03702 7.93907C2.30575 7.67034 2.67023 7.51937 3.05028 7.51937H3.11477C3.35192 7.51382 3.58192 7.43706 3.77486 7.29905C3.96781 7.16105 4.11478 6.9682 4.19666 6.74556C4.29203 6.52946 4.32049 6.28974 4.27834 6.05731C4.2362 5.82489 4.1254 5.61042 3.96022 5.44156L3.91723 5.39857C3.784 5.26548 3.6783 5.10744 3.60619 4.93348C3.53408 4.75952 3.49696 4.57305 3.49696 4.38474C3.49696 4.19642 3.53408 4.00996 3.60619 3.836C3.6783 3.66204 3.784 3.504 3.91723 3.37091C4.05031 3.23768 4.20836 3.13198 4.38232 3.05987C4.55628 2.98776 4.74274 2.95064 4.93106 2.95064C5.11937 2.95064 5.30584 2.98776 5.4798 3.05987C5.65376 3.13198 5.8118 3.23768 5.94489 3.37091L5.98788 3.4139C6.15674 3.57908 6.37121 3.68988 6.60363 3.73202C6.83606 3.77417 7.07578 3.74572 7.29188 3.65034H7.3492C7.56111 3.55952 7.74185 3.40871 7.86915 3.21648C7.99645 3.02426 8.06477 2.799 8.06568 2.56845V2.44664C8.06568 2.0666 8.21666 1.70211 8.48539 1.43338C8.75413 1.16465 9.11861 1.01367 9.49866 1.01367C9.87871 1.01367 10.2432 1.16465 10.5119 1.43338C10.7807 1.70211 10.9316 2.0666 10.9316 2.44664V2.51113C10.9325 2.74168 11.0009 2.96694 11.1282 3.15917C11.2555 3.35139 11.4362 3.5022 11.6481 3.59302C11.8642 3.6884 12.1039 3.71685 12.3364 3.6747C12.5688 3.63256 12.7833 3.52176 12.9521 3.35658L12.9951 3.31359C13.1282 3.18036 13.2862 3.07467 13.4602 3.00255C13.6342 2.93044 13.8206 2.89332 14.0089 2.89332C14.1973 2.89332 14.3837 2.93044 14.5577 3.00255C14.7316 3.07467 14.8897 3.18036 15.0228 3.31359C15.156 3.44668 15.2617 3.60472 15.3338 3.77868C15.4059 3.95264 15.443 4.13911 15.443 4.32742C15.443 4.51574 15.4059 4.7022 15.3338 4.87616C15.2617 5.05012 15.156 5.20816 15.0228 5.34125L14.9798 5.38424C14.8146 5.5531 14.7038 5.76757 14.6617 5.99999C14.6195 6.23242 14.648 6.47214 14.7433 6.68824V6.74556C14.8342 6.95748 14.985 7.13821 15.1772 7.26551C15.3694 7.39281 15.5947 7.46113 15.8252 7.46205H15.947C16.3271 7.46205 16.6916 7.61302 16.9603 7.88176C17.229 8.15049 17.38 8.51497 17.38 8.89502C17.38 9.27507 17.229 9.63955 16.9603 9.90828C16.6916 10.177 16.3271 10.328 15.947 10.328H15.8825C15.652 10.3289 15.4267 10.3972 15.2345 10.5245C15.0423 10.6518 14.8915 10.8326 14.8007 11.0445V11.0445Z"
        stroke="#121418"
        strokeWidth="1.75141"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  logout: (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.3335 14.1668L12.5002 10.0002L8.3335 5.8335"
        stroke="#121418"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5 10H2.5"
        stroke="#121418"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5"
        stroke="#121418"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  warning: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      className="iconify iconify--emojione"
      preserveAspectRatio="xMidYMid meet"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M5.9 62c-3.3 0-4.8-2.4-3.3-5.3L29.3 4.2c1.5-2.9 3.9-2.9 5.4 0l26.7 52.5c1.5 2.9 0 5.3-3.3 5.3H5.9z"
          fill="#ffce31"
        ></path>
        <g fill="#121212">
          <path d="M27.8 23.6l2.8 18.5c.3 1.8 2.6 1.8 2.9 0l2.7-18.5c.5-7.2-8.9-7.2-8.4 0"></path>
          <circle cx="32" cy="49.6" r="4.2"></circle>
        </g>
      </g>
    </svg>
  ),
  camera: (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7161 2.78409C12.7471 2.83828 12.8014 2.87699 12.8711 2.87699C14.7311 2.87699 16.2501 4.3943 16.2501 6.25224V10.8506C16.2501 12.7086 14.7311 14.2259 12.8711 14.2259H4.12912C2.26137 14.2259 0.750122 12.7086 0.750122 10.8506V6.25224C0.750122 4.3943 2.26137 2.87699 4.12912 2.87699C4.19112 2.87699 4.25312 2.84602 4.27637 2.78409L4.32287 2.6912C4.34959 2.63496 4.37701 2.57719 4.40485 2.51855C4.60312 2.10095 4.82246 1.63894 4.95837 1.36742C5.31487 0.67069 5.91937 0.28362 6.67112 0.275879H10.3214C11.0731 0.28362 11.6854 0.67069 12.0419 1.36742C12.1639 1.61127 12.3499 2.00406 12.5291 2.38264C12.5661 2.46077 12.6028 2.5383 12.6386 2.61378L12.7161 2.78409ZM12.1503 5.75654C12.1503 6.14361 12.4603 6.45327 12.8478 6.45327C13.2353 6.45327 13.553 6.14361 13.553 5.75654C13.553 5.36947 13.2353 5.05207 12.8478 5.05207C12.4603 5.05207 12.1503 5.36947 12.1503 5.75654ZM7.15932 6.95662C7.52357 6.59278 7.99632 6.39924 8.50007 6.39924C9.00382 6.39924 9.47657 6.59278 9.83307 6.94888C10.1896 7.30499 10.3833 7.77721 10.3833 8.2804C10.3756 9.31775 9.53857 10.1616 8.50007 10.1616C7.99632 10.1616 7.52357 9.96803 7.16707 9.61192C6.81057 9.25582 6.61682 8.78359 6.61682 8.2804V8.27266C6.60907 7.78495 6.80282 7.31273 7.15932 6.95662ZM10.6468 10.4324C10.0966 10.982 9.33708 11.3226 8.50008 11.3226C7.68633 11.3226 6.92683 11.0052 6.34558 10.4324C5.77208 9.85175 5.45433 9.09309 5.45433 8.28025C5.44658 7.47514 5.76433 6.71649 6.33783 6.13588C6.91908 5.55528 7.68633 5.23788 8.50008 5.23788C9.31383 5.23788 10.0811 5.55528 10.6546 6.12814C11.2281 6.70874 11.5458 7.47514 11.5458 8.28025C11.5381 9.12406 11.1971 9.88272 10.6468 10.4324Z"
        fill="white"
      />
    </svg>
  ),
  edit: (
    <svg width="17" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="style=fill">
          <g id="edit">
            <path
              id="Subtract"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.9405 3.12087L21.0618 5.24219C22.2334 6.41376 22.2334 8.31326 21.0618 9.48483L19.2586 11.288L12.8947 4.92403L14.6978 3.12087C15.8694 1.94929 17.7689 1.94929 18.9405 3.12087ZM11.834 5.98469L3.70656 14.1121C3.22329 14.5954 2.91952 15.2292 2.84552 15.9086L2.45151 19.5264C2.31313 20.7969 3.38571 21.8695 4.65629 21.7311L8.27401 21.3371C8.95345 21.2631 9.58725 20.9594 10.0705 20.4761L18.1979 12.3486L11.834 5.98469Z"
              fill="#fff"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  cross: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5 c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4 C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"
        ></path>
      </g>
    </svg>
  ),
  passportIcon: (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="16.897" y="8.6875" width="39.3954" height="56.1749" rx="6.63222" fill="#E0E6F3" />
      <path
        d="M45.2262 48.648H27.9617C27.4912 48.648 27.1099 48.0314 27.1099 47.2708C27.1099 46.5101 27.4912 45.8936 27.9617 45.8936H45.2262C45.6967 45.8936 46.078 46.5101 46.078 47.2708C46.078 48.0314 45.6967 48.648 45.2262 48.648Z"
        fill="black"
      />
      <path
        d="M51.4972 43.5406H28.2566C27.6232 43.5406 27.1099 42.924 27.1099 42.1634C27.1099 41.4027 27.6232 40.7861 28.2566 40.7861H51.4972C52.1305 40.7861 52.6439 41.4027 52.6439 42.1634C52.6439 42.924 52.1305 43.5406 51.4972 43.5406Z"
        fill="black"
      />
      <g clipPath="url(#clip0_706_17846)">
        <path
          d="M38.7749 19.0215C34.4122 19.0215 30.8794 22.5622 30.8794 26.9249C30.8794 31.2876 34.4122 34.8283 38.7749 34.8283C43.1455 34.8283 46.6862 31.2876 46.6862 26.9249C46.6862 22.5622 43.1455 19.0215 38.7749 19.0215ZM44.2519 23.7635H41.9204C41.6675 22.7756 41.304 21.8272 40.8298 20.9499C42.284 21.4478 43.4932 22.4595 44.2519 23.7635ZM38.7828 20.6338C39.4388 21.5822 39.9525 22.6333 40.2923 23.7635H37.2732C37.6131 22.6333 38.1268 21.5822 38.7828 20.6338ZM32.6656 28.5056C32.5391 27.9997 32.4601 27.4702 32.4601 26.9249C32.4601 26.3796 32.5391 25.85 32.6656 25.3442H35.3369C35.2737 25.8658 35.2263 26.3875 35.2263 26.9249C35.2263 27.4623 35.2737 27.9839 35.3369 28.5056H32.6656ZM33.3136 30.0862H35.6451C35.8981 31.0742 36.2616 32.0226 36.7358 32.8999C35.2816 32.4019 34.0724 31.3982 33.3136 30.0862ZM35.6451 23.7635H33.3136C34.0724 22.4516 35.2816 21.4478 36.7358 20.9499C36.2616 21.8272 35.8981 22.7756 35.6451 23.7635ZM38.7828 33.216C38.1268 32.2676 37.6131 31.2164 37.2732 30.0862H40.2923C39.9525 31.2164 39.4388 32.2676 38.7828 33.216ZM40.6322 28.5056H36.9334C36.8623 27.9839 36.8069 27.4623 36.8069 26.9249C36.8069 26.3875 36.8623 25.8579 36.9334 25.3442H40.6322C40.7033 25.8579 40.7586 26.3875 40.7586 26.9249C40.7586 27.4623 40.7033 27.9839 40.6322 28.5056ZM40.8298 32.8999C41.304 32.0226 41.6675 31.0742 41.9204 30.0862H44.2519C43.4932 31.3903 42.284 32.4019 40.8298 32.8999ZM42.2287 28.5056C42.2919 27.9839 42.3393 27.4623 42.3393 26.9249C42.3393 26.3875 42.2919 25.8658 42.2287 25.3442H44.9C45.0265 25.85 45.1055 26.3796 45.1055 26.9249C45.1055 27.4702 45.0265 27.9997 44.9 28.5056H42.2287Z"
          fill="black"
        />
      </g>
      <path
        d="M16.897 14.5239C16.897 11.3005 19.51 8.6875 22.7333 8.6875V64.8624C19.51 64.8624 16.897 62.2494 16.897 59.0261V14.5239Z"
        fill="black"
      />
      <defs>
        <clipPath id="clip0_706_17846">
          <rect
            width="18.9682"
            height="18.9682"
            fill="white"
            transform="translate(29.2993 17.4404)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  nationalIdIcon: (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63.5878 22.4851V51.6874C63.5878 53.7067 61.9512 55.3434 59.9318 55.3434H13.9871C11.9677 55.3434 10.3311 53.7067 10.3311 51.6874V22.4851C10.3311 20.4658 11.9677 18.8291 13.9871 18.8291H59.9317C61.9511 18.829 63.5878 20.4658 63.5878 22.4851V22.4851Z"
        fill="#E0E6F3"
      />
      <path
        d="M58.1039 50.7742H15.8153C15.3106 50.7742 14.9014 50.365 14.9014 49.8603C14.9014 49.3555 15.3106 48.9463 15.8153 48.9463H58.1039C58.6087 48.9463 59.0179 49.3555 59.0179 49.8603C59.0179 50.3649 58.6087 50.7742 58.1039 50.7742Z"
        fill="white"
      />
      <path
        d="M58.1039 47.118H15.8153C15.3106 47.118 14.9014 46.7088 14.9014 46.204C14.9014 45.6992 15.3106 45.29 15.8153 45.29H58.1039C58.6087 45.29 59.0179 45.6992 59.0179 46.204C59.0179 46.7088 58.6087 47.118 58.1039 47.118Z"
        fill="white"
      />
      <path
        d="M58.1036 43.4617H39.5795C39.0747 43.4617 38.6655 43.0525 38.6655 42.5478C38.6655 42.043 39.0747 41.6338 39.5795 41.6338H58.1036C58.6084 41.6338 59.0176 42.043 59.0176 42.5478C59.0176 43.0524 58.6084 43.4617 58.1036 43.4617Z"
        fill="white"
      />
      <path
        d="M58.1036 39.8055H39.5795C39.0747 39.8055 38.6655 39.3963 38.6655 38.8915C38.6655 38.3867 39.0747 37.9775 39.5795 37.9775H58.1036C58.6084 37.9775 59.0176 38.3867 59.0176 38.8915C59.0176 39.3963 58.6084 39.8055 58.1036 39.8055Z"
        fill="white"
      />
      <path
        d="M30.4085 42.6417H19.4861C17.4669 42.6417 15.8301 41.0048 15.8301 38.9856V28.0632C15.8301 26.044 17.467 24.4072 19.4861 24.4072H30.4085C32.4277 24.4072 34.0645 26.0441 34.0645 28.0632V38.9856C34.0645 41.0048 32.4277 42.6417 30.4085 42.6417Z"
        fill="#67728D"
      />
      <path
        d="M30.4085 42.6417H19.4861C17.4669 42.6417 15.8301 41.0048 15.8301 38.9856V28.0632C15.8301 26.044 17.467 24.4072 19.4861 24.4072H30.4085C32.4277 24.4072 34.0645 26.0441 34.0645 28.0632V38.9856C34.0645 41.0048 32.4277 42.6417 30.4085 42.6417Z"
        fill="white"
      />
      <path
        d="M22.0499 28.9668C22.1674 28.9668 22.2793 28.9881 22.3854 29.0306C22.4916 29.0771 22.5826 29.139 22.6584 29.2163C22.7342 29.2937 22.7949 29.3866 22.8404 29.4949C22.8859 29.6032 22.9086 29.7193 22.9086 29.8431C22.9086 29.9669 22.8859 30.0811 22.8404 30.1855C22.7949 30.2939 22.7342 30.3867 22.6584 30.4641C22.5826 30.5454 22.4916 30.6092 22.3854 30.6556C22.2793 30.702 22.1674 30.7253 22.0499 30.7253C21.9286 30.7253 21.8148 30.702 21.7087 30.6556C21.6063 30.6092 21.5172 30.5454 21.4414 30.4641C21.3655 30.3867 21.3068 30.2939 21.2651 30.1855C21.2196 30.0811 21.1968 29.9669 21.1968 29.8431C21.1968 29.7193 21.2196 29.6032 21.2651 29.4949C21.3068 29.3866 21.3655 29.2937 21.4414 29.2163C21.5172 29.139 21.6063 29.0771 21.7087 29.0306C21.8148 28.9881 21.9286 28.9668 22.0499 28.9668ZM26.9142 28.9668C27.0317 28.9668 27.1436 28.9881 27.2498 29.0306C27.3559 29.0771 27.4469 29.139 27.5227 29.2163C27.5986 29.2937 27.6592 29.3866 27.7047 29.4949C27.7502 29.6032 27.773 29.7193 27.773 29.8431C27.773 29.9669 27.7502 30.0811 27.7047 30.1855C27.6592 30.2939 27.5986 30.3867 27.5227 30.4641C27.4469 30.5454 27.3559 30.6092 27.2498 30.6556C27.1436 30.702 27.0317 30.7253 26.9142 30.7253C26.7929 30.7253 26.6792 30.702 26.573 30.6556C26.4706 30.6092 26.3815 30.5454 26.3057 30.4641C26.2299 30.3867 26.1692 30.2939 26.1237 30.1855C26.082 30.0811 26.0612 29.9669 26.0612 29.8431C26.0612 29.7193 26.082 29.6032 26.1237 29.4949C26.1692 29.3866 26.2299 29.2937 26.3057 29.2163C26.3815 29.139 26.4706 29.0771 26.573 29.0306C26.6792 28.9881 26.7929 28.9668 26.9142 28.9668Z"
        fill="black"
      />
      <path
        d="M25.2972 32.0057L25.2972 35.0119L24.1256 35.0119L24.1256 32.0057L25.2972 32.0057Z"
        fill="black"
      />
      <path
        d="M24.8422 37.1887C25.6232 37.1887 26.391 37.092 27.1455 36.8986C27.9037 36.709 28.6127 36.4343 29.2724 36.0745C29.352 36.0319 29.4203 36.0068 29.4771 35.999C29.5378 35.9952 29.589 36.001 29.6307 36.0164C29.6762 36.0319 29.7141 36.0551 29.7444 36.0861C29.7786 36.1209 29.807 36.1596 29.8297 36.2021L30.2051 36.8405C29.7729 37.1268 29.3388 37.3706 28.9027 37.5718C28.4705 37.773 28.0326 37.9374 27.589 38.0651C27.1455 38.1927 26.6943 38.2856 26.2355 38.3436C25.7806 38.4017 25.3161 38.4307 24.8422 38.4307C24.3683 38.4307 23.9038 38.4017 23.4489 38.3436C22.9939 38.2856 22.5446 38.1927 22.1011 38.0651C21.6575 37.9374 21.2177 37.773 20.7817 37.5718C20.444 37.4159 20.0495 37.1989 19.7328 37.0035C19.6406 36.9467 19.555 36.8917 19.4793 36.8405L19.6699 36.5213L19.8604 36.2021C19.8831 36.1596 19.9115 36.1209 19.9457 36.0861C19.976 36.0551 20.0139 36.0319 20.0594 36.0164C20.1011 36.001 20.1523 35.9952 20.213 35.999C20.2698 36.0068 20.3362 36.0319 20.412 36.0745C21.0755 36.4343 21.7845 36.709 22.539 36.8986C23.2934 37.092 24.0612 37.1887 24.8422 37.1887Z"
        fill="black"
      />
      <path
        d="M50.6836 28.7225H39.4716C38.9668 28.7225 38.5576 28.3133 38.5576 27.8085C38.5576 27.3037 38.9668 26.8945 39.4716 26.8945H50.6836C51.1884 26.8945 51.5976 27.3037 51.5976 27.8085C51.5976 28.3133 51.1884 28.7225 50.6836 28.7225Z"
        fill="white"
      />
      <path
        d="M58.1036 25.2264H39.5795C39.0747 25.2264 38.6655 24.8172 38.6655 24.3124C38.6655 23.8076 39.0747 23.3984 39.5795 23.3984H58.1036C58.6084 23.3984 59.0176 23.8076 59.0176 24.3124C59.0176 24.8172 58.6084 25.2264 58.1036 25.2264Z"
        fill="white"
      />
    </svg>
  ),
  licenseIcon: (
    <svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_706_17857)">
        <path
          d="M66.1263 23.6616V54.032C66.1263 56.1321 64.4242 57.8342 62.324 57.8342H14.5415C12.4414 57.8342 10.7393 56.1321 10.7393 54.032V23.6616C10.7393 21.5615 12.4414 19.8594 14.5415 19.8594H62.3239C64.4242 19.8593 66.1263 21.5615 66.1263 23.6616V23.6616Z"
          fill="#E0E6F3"
        />
        <path
          d="M60.4228 53.0827H16.4427C15.9178 53.0827 15.4922 52.6572 15.4922 52.1322C15.4922 51.6072 15.9178 51.1816 16.4427 51.1816H60.4228C60.9478 51.1816 61.3734 51.6072 61.3734 52.1322C61.3734 52.657 60.9478 53.0827 60.4228 53.0827Z"
          fill="white"
        />
        <path
          d="M60.4228 49.279H16.4427C15.9178 49.279 15.4922 48.8534 15.4922 48.3285C15.4922 47.8035 15.9178 47.3779 16.4427 47.3779H60.4228C60.9478 47.3779 61.3734 47.8035 61.3734 48.3285C61.3734 48.8534 60.9478 49.279 60.4228 49.279Z"
          fill="white"
        />
        <path
          d="M60.4227 45.4772H41.1576C40.6326 45.4772 40.207 45.0517 40.207 44.5267C40.207 44.0017 40.6326 43.5762 41.1576 43.5762H60.4227C60.9476 43.5762 61.3732 44.0017 61.3732 44.5267C61.3732 45.0516 60.9476 45.4772 60.4227 45.4772Z"
          fill="white"
        />
        <path
          d="M60.4227 41.6755H41.1576C40.6326 41.6755 40.207 41.2499 40.207 40.7249C40.207 40.2 40.6326 39.7744 41.1576 39.7744H60.4227C60.9476 39.7744 61.3732 40.2 61.3732 40.7249C61.3732 41.2499 60.9476 41.6755 60.4227 41.6755Z"
          fill="white"
        />
        <path
          d="M31.6196 44.625H20.2603C18.1603 44.625 16.458 42.9226 16.458 40.8227V29.4634C16.458 27.3634 18.1604 25.6611 20.2603 25.6611H31.6196C33.7196 25.6611 35.4218 27.3635 35.4218 29.4634V40.8227C35.4218 42.9226 33.7196 44.625 31.6196 44.625Z"
          fill="#67728D"
        />
        <path
          d="M31.6196 44.6249H20.2603C18.1603 44.6249 16.458 42.9226 16.458 40.8227V29.4634C16.458 27.3634 18.1604 25.6611 20.2603 25.6611H31.6196C33.7196 25.6611 35.4218 27.3635 35.4218 29.4634V40.8227C35.4218 42.9226 33.7196 44.6249 31.6196 44.6249Z"
          fill="white"
        />
        <path
          d="M22.9268 30.4033C23.049 30.4033 23.1653 30.4255 23.2757 30.4697C23.3862 30.518 23.4808 30.5824 23.5596 30.6629C23.6385 30.7433 23.7016 30.8399 23.7489 30.9526C23.7962 31.0652 23.8199 31.1859 23.8199 31.3147C23.8199 31.4435 23.7962 31.5622 23.7489 31.6708C23.7016 31.7835 23.6385 31.88 23.5596 31.9605C23.4808 32.045 23.3862 32.1114 23.2757 32.1597C23.1653 32.208 23.049 32.2321 22.9268 32.2321C22.8006 32.2321 22.6823 32.208 22.5719 32.1597C22.4655 32.1114 22.3728 32.045 22.2939 31.9605C22.2151 31.88 22.154 31.7835 22.1106 31.6708C22.0633 31.5622 22.0396 31.4435 22.0396 31.3147C22.0396 31.1859 22.0633 31.0652 22.1106 30.9526C22.154 30.8399 22.2151 30.7433 22.2939 30.6629C22.3728 30.5824 22.4655 30.518 22.5719 30.4697C22.6823 30.4255 22.8006 30.4033 22.9268 30.4033ZM27.9857 30.4033C28.1079 30.4033 28.2243 30.4255 28.3347 30.4697C28.4451 30.518 28.5397 30.5824 28.6186 30.6629C28.6974 30.7433 28.7605 30.8399 28.8078 30.9526C28.8551 31.0652 28.8788 31.1859 28.8788 31.3147C28.8788 31.4435 28.8551 31.5622 28.8078 31.6708C28.7605 31.7835 28.6974 31.88 28.6186 31.9605C28.5397 32.045 28.4451 32.1114 28.3347 32.1597C28.2243 32.208 28.1079 32.2321 27.9857 32.2321C27.8595 32.2321 27.7412 32.208 27.6308 32.1597C27.5244 32.1114 27.4317 32.045 27.3529 31.9605C27.274 31.88 27.2109 31.7835 27.1636 31.6708C27.1202 31.5622 27.0985 31.4435 27.0985 31.3147C27.0985 31.1859 27.1202 31.0652 27.1636 30.9526C27.2109 30.8399 27.274 30.7433 27.3529 30.6629C27.4317 30.5824 27.5244 30.518 27.6308 30.4697C27.7412 30.4255 27.8595 30.4033 27.9857 30.4033Z"
          fill="black"
        />
        <path
          d="M26.304 33.5637L26.304 36.6902L25.0856 36.6902L25.0856 33.5637L26.304 33.5637Z"
          fill="black"
        />
        <path
          d="M25.8308 38.9541C26.6431 38.9541 27.4415 38.8535 28.2262 38.6524C29.0148 38.4552 29.7521 38.1695 30.4382 37.7953C30.521 37.751 30.592 37.7249 30.6511 37.7168C30.7142 37.7128 30.7675 37.7188 30.8108 37.7349C30.8582 37.751 30.8976 37.7752 30.9291 37.8074C30.9646 37.8436 30.9942 37.8838 31.0178 37.9281L31.4082 38.592C30.9587 38.8898 30.5072 39.1433 30.0538 39.3525C29.6043 39.5617 29.1489 39.7327 28.6875 39.8655C28.2262 39.9983 27.757 40.0949 27.2799 40.1552C26.8067 40.2156 26.3237 40.2458 25.8308 40.2458C25.3379 40.2458 24.8549 40.2156 24.3818 40.1552C23.9086 40.0949 23.4414 39.9983 22.98 39.8655C22.5187 39.7327 22.0613 39.5617 21.6079 39.3525C21.2566 39.1904 20.8464 38.9647 20.517 38.7615C20.4212 38.7024 20.3321 38.6452 20.2534 38.592L20.4516 38.26L20.6497 37.9281C20.6734 37.8838 20.7029 37.8436 20.7384 37.8074C20.77 37.7752 20.8094 37.751 20.8567 37.7349C20.9001 37.7188 20.9533 37.7128 21.0164 37.7168C21.0755 37.7249 21.1446 37.751 21.2234 37.7953C21.9134 38.1695 22.6508 38.4552 23.4354 38.6524C24.2201 38.8535 25.0186 38.9541 25.8308 38.9541Z"
          fill="black"
        />
        <path
          d="M52.7052 30.1481H41.0448C40.5198 30.1481 40.0942 29.7226 40.0942 29.1976C40.0942 28.6726 40.5198 28.2471 41.0448 28.2471H52.7052C53.2302 28.2471 53.6558 28.6726 53.6558 29.1976C53.6558 29.7226 53.2302 30.1481 52.7052 30.1481Z"
          fill="white"
        />
        <path
          d="M60.4227 26.5134H41.1576C40.6326 26.5134 40.207 26.0878 40.207 25.5628C40.207 25.0379 40.6326 24.6123 41.1576 24.6123H60.4227C60.9476 24.6123 61.3732 25.0379 61.3732 25.5628C61.3732 26.0878 60.9476 26.5134 60.4227 26.5134Z"
          fill="white"
        />
        <path
          d="M51.5506 31.5322C42.0826 31.5322 34.4062 39.2086 34.4062 48.6765C34.4062 58.1445 42.0826 65.8208 51.5506 65.8208C61.0185 65.8208 68.6949 58.1445 68.6949 48.6765C68.6949 39.2086 61.0185 31.5322 51.5506 31.5322ZM51.5506 35.8183C57.1299 35.8183 61.8425 39.4122 63.6223 44.3905H39.4788C41.2586 39.4122 45.9712 35.8183 51.5506 35.8183ZM51.5506 50.8196C50.3665 50.8196 49.4075 49.8606 49.4075 48.6765C49.4075 47.4925 50.3665 46.5335 51.5506 46.5335C52.7346 46.5335 53.6936 47.4925 53.6936 48.6765C53.6936 49.8606 52.7346 50.8196 51.5506 50.8196ZM38.6923 48.6765C44.5482 48.6765 49.2907 54.3191 49.3904 61.3172C43.3299 60.2789 38.6923 55.0263 38.6923 48.6765ZM53.7107 61.3172C53.8104 54.3191 58.5529 48.6765 64.4088 48.6765C64.4088 55.0263 59.7712 60.2789 53.7107 61.3172Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_17857">
          <rect
            width="72.9545"
            height="72.9545"
            fill="white"
            transform="translate(0.117188 0.890625)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  info: (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_706_17841)">
        <path
          d="M17.5265 3.36035C9.71811 3.36035 3.38086 9.69761 3.38086 17.506C3.38086 25.3144 9.71811 31.6517 17.5265 31.6517C25.3349 31.6517 31.6722 25.3144 31.6722 17.506C31.6722 9.69761 25.3349 3.36035 17.5265 3.36035ZM18.9411 24.5788H16.1119V21.7497H18.9411V24.5788ZM18.9411 18.9206H16.1119V10.4332H18.9411V18.9206Z"
          fill="#0055FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_17841">
          <rect
            width="33.9496"
            height="33.9496"
            fill="white"
            transform="translate(0.55127 0.53125)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  moreInfo: (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="10" r="9" fill="#D9D9D9" />
      <path
        d="M8.24805 11.9084V11.8409C8.25278 11.4006 8.29658 11.0502 8.37944 10.7898C8.46467 10.5294 8.5854 10.3187 8.74165 10.1577C8.8979 9.99669 9.08612 9.84991 9.30629 9.71733C9.44833 9.62737 9.57617 9.52675 9.68981 9.41548C9.80344 9.30421 9.89341 9.17637 9.95969 9.03196C10.026 8.88755 10.0591 8.72775 10.0591 8.55256C10.0591 8.34186 10.0094 8.15956 9.90998 8.00568C9.81055 7.8518 9.67797 7.73343 9.51225 7.65057C9.3489 7.56534 9.16661 7.52273 8.96538 7.52273C8.78308 7.52273 8.60908 7.56061 8.44336 7.63636C8.27764 7.71212 8.14033 7.83049 8.03143 7.99148C7.92253 8.15009 7.85979 8.35488 7.84322 8.60582H6.76367C6.78024 8.17969 6.88796 7.81984 7.08683 7.52628C7.28569 7.23035 7.54847 7.00663 7.87518 6.85511C8.20425 6.7036 8.56765 6.62784 8.96538 6.62784C9.40098 6.62784 9.78214 6.70952 10.1088 6.87287C10.4355 7.03385 10.6889 7.25994 10.8688 7.55114C11.0511 7.83996 11.1422 8.17732 11.1422 8.56321C11.1422 8.82836 11.1008 9.06747 11.0179 9.28054C10.9351 9.49124 10.8167 9.67945 10.6628 9.84517C10.5113 10.0109 10.329 10.1577 10.1159 10.2855C9.91471 10.411 9.75136 10.5412 9.62589 10.6761C9.50278 10.8111 9.41282 10.9709 9.356 11.1555C9.29918 11.3402 9.26841 11.5687 9.26367 11.8409V11.9084H8.24805ZM8.78427 14.0675C8.59014 14.0675 8.42324 13.9988 8.28356 13.8615C8.14388 13.7218 8.07404 13.5537 8.07404 13.3572C8.07404 13.1631 8.14388 12.9974 8.28356 12.8601C8.42324 12.7204 8.59014 12.6506 8.78427 12.6506C8.97603 12.6506 9.14175 12.7204 9.28143 12.8601C9.42347 12.9974 9.4945 13.1631 9.4945 13.3572C9.4945 13.4875 9.46135 13.607 9.39506 13.7159C9.33114 13.8224 9.24592 13.9077 9.13938 13.9716C9.03285 14.0355 8.91448 14.0675 8.78427 14.0675Z"
        fill="white"
      />
    </svg>
  ),
  unCheckIcon: (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.14237" y="1.5164" width="34.9863" height="34.9863" rx="10.8642" fill="white" />
      <rect
        x="1.14237"
        y="1.5164"
        width="34.9863"
        height="34.9863"
        rx="10.8642"
        stroke="#D0D9ED"
        strokeWidth="1.84138"
        fill="none"
      />
      <path
        d="M25.1273 13.9922L15.6326 23.1991L11.3169 19.0141"
        stroke="white"
        strokeWidth="2.30173"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkIcon: (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.14237" y="1.77421" width="34.9863" height="34.9863" rx="10.8642" fill="#121418" />
      <rect
        x="1.14237"
        y="1.77421"
        width="34.9863"
        height="34.9863"
        rx="10.8642"
        stroke="#121418"
        strokeWidth="1.84138"
        fill="none"
      />
      <path
        d="M25.1273 14.25L15.6326 23.4569L11.3169 19.272"
        stroke="#FDFAFB"
        strokeWidth="2.30173"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  internet: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.073 11.7171C14.7594 10.5988 15.1218 9.31206 15.12 8.00001L15.12 7.99989L15.12 7.99976C15.1218 6.68771 14.7594 5.4009 14.073 4.28269L14.0691 4.27658C13.4323 3.23873 12.54 2.3815 11.4775 1.78682C10.415 1.19215 9.21766 0.879888 8.00003 0.879883C6.7824 0.879878 5.58511 1.19213 4.52256 1.7868C3.46002 2.38146 2.56772 3.23868 1.93094 4.27654L1.92699 4.28272C1.24232 5.4017 0.88001 6.68804 0.880005 7.99987C0.88 9.31169 1.2423 10.598 1.92696 11.717L1.93098 11.7233C2.56776 12.7611 3.46006 13.6183 4.52259 14.213C5.58513 14.8076 6.78241 15.1199 8.00003 15.1199C9.21765 15.1199 10.4149 14.8076 11.4775 14.213C12.54 13.6183 13.4323 12.7611 14.069 11.7232L14.073 11.7171ZM8.9101 13.8996C8.77443 14.0305 8.61827 14.1384 8.4478 14.2189C8.30788 14.2854 8.15491 14.3199 8 14.3199C7.84509 14.3199 7.69212 14.2854 7.5522 14.2189C7.2278 14.0532 6.95011 13.8088 6.74451 13.5081C6.32461 12.9014 6.01344 12.2262 5.82489 11.5128C6.54919 11.4683 7.27423 11.4456 8.00001 11.4447C8.72547 11.4447 9.45055 11.4674 10.1752 11.5128C10.0709 11.8796 9.94052 12.2385 9.78516 12.5868C9.58058 13.0766 9.28347 13.5223 8.9101 13.8996V13.8996ZM1.69393 8.39989H4.56577C4.58446 9.20124 4.67132 9.99954 4.8254 10.7862C4.04036 10.8552 3.25731 10.9501 2.47627 11.0708C2.01891 10.2503 1.75156 9.33752 1.69393 8.39989ZM2.47627 4.92897C3.257 5.04995 4.04032 5.14486 4.82623 5.21368C4.67184 6.00024 4.58479 6.79853 4.56602 7.59989H1.69393C1.75155 6.66226 2.01891 5.74952 2.47626 4.92897H2.47627ZM7.0899 2.10015C7.22557 1.96923 7.38173 1.86138 7.5522 1.78085C7.69212 1.71437 7.84509 1.67987 8 1.67987C8.15491 1.67987 8.30788 1.71437 8.4478 1.78085C8.7722 1.94655 9.04989 2.19092 9.25549 2.49162C9.67539 3.09838 9.98656 3.77354 10.1751 4.48693C9.4508 4.5315 8.72577 4.5542 8.00001 4.55504C7.27454 4.55503 6.54946 4.53232 5.82476 4.48692C5.92913 4.12013 6.05948 3.76124 6.21485 3.41297C6.41942 2.92318 6.71653 2.47743 7.0899 2.10015ZM14.3061 7.59989H11.4342C11.4155 6.79854 11.3287 6.00023 11.1746 5.21361C11.9597 5.14453 12.7427 5.04964 13.5237 4.92897C13.9811 5.74951 14.2485 6.66225 14.3061 7.59989ZM5.63002 10.724C5.47357 9.95859 5.38521 9.18086 5.36597 8.39989H10.6341C10.6151 9.18085 10.5269 9.95859 10.3706 10.724C9.58124 10.6722 8.79105 10.6458 8.00001 10.6447C7.20953 10.6447 6.41953 10.6711 5.63002 10.724ZM10.37 5.2758C10.5264 6.04118 10.6148 6.81892 10.634 7.59989H5.36588C5.38494 6.81892 5.47314 6.04117 5.62945 5.27576C6.41876 5.32755 7.20895 5.35397 8.00001 5.35503C8.79048 5.35503 9.58048 5.32862 10.37 5.2758V5.2758ZM11.434 8.39989H14.3061C14.2485 9.33752 13.9811 10.2503 13.5237 11.0708C12.743 10.9498 11.9597 10.8549 11.1738 10.7861C11.3282 9.99953 11.4152 9.20124 11.434 8.39989ZM13.0441 4.19265C12.3615 4.29114 11.6768 4.36911 10.9901 4.42657C10.8667 3.96706 10.7075 3.51792 10.514 3.08324C10.3374 2.68323 10.1151 2.30498 9.85166 1.95599C11.1249 2.34648 12.2422 3.12929 13.0441 4.19265ZM3.53107 3.53095C4.26146 2.79987 5.16003 2.25911 6.14801 1.95609C6.13302 1.9755 6.1176 1.99405 6.10283 2.01387C5.59501 2.74491 5.2251 3.56262 5.01137 4.42669C4.32463 4.36853 3.63949 4.29051 2.95594 4.19265C3.13223 3.95914 3.32439 3.73805 3.53107 3.53095ZM2.95593 11.8071C3.63854 11.7086 4.32319 11.6306 5.0099 11.5732C5.13332 12.0327 5.29249 12.4819 5.48597 12.9165C5.66262 13.3165 5.88488 13.6948 6.14834 14.0438C4.87509 13.6533 3.75777 12.8705 2.95593 11.8071V11.8071ZM12.4689 12.4688C11.7386 13.1999 10.84 13.7407 9.85199 14.0437C9.86698 14.0243 9.88239 14.0057 9.89717 13.9859C10.405 13.2549 10.7749 12.4371 10.9886 11.5731C11.6754 11.6312 12.3605 11.7093 13.0441 11.8071C12.8678 12.0406 12.6756 12.2617 12.4689 12.4688V12.4688Z"
        fill="#051036"
      />
    </svg>
  ),
  facebook: (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.62891 8.31543L8.01172 5.7998H5.57812V4.15918C5.57812 3.44824 5.90625 2.79199 7 2.79199H8.12109V0.631836C8.12109 0.631836 7.10938 0.44043 6.15234 0.44043C4.15625 0.44043 2.84375 1.6709 2.84375 3.8584V5.7998H0.601562V8.31543H2.84375V14.4404H5.57812V8.31543H7.62891Z"
        fill="#051036"
      />
    </svg>
  ),
  twitter: (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5508 3.59668C13.0977 3.18652 13.5898 2.69434 13.9727 2.12012C13.4805 2.33887 12.9062 2.50293 12.332 2.55762C12.9336 2.20215 13.3711 1.65527 13.5898 0.97168C13.043 1.2998 12.4141 1.5459 11.7852 1.68262C11.2383 1.1084 10.5 0.780273 9.67969 0.780273C8.09375 0.780273 6.80859 2.06543 6.80859 3.65137C6.80859 3.87012 6.83594 4.08887 6.89062 4.30762C4.51172 4.1709 2.37891 3.02246 0.957031 1.2998C0.710938 1.70996 0.574219 2.20215 0.574219 2.74902C0.574219 3.7334 1.06641 4.6084 1.85938 5.12793C1.39453 5.10059 0.929688 4.99121 0.546875 4.77246V4.7998C0.546875 6.19434 1.53125 7.34277 2.84375 7.61621C2.625 7.6709 2.35156 7.72559 2.10547 7.72559C1.91406 7.72559 1.75 7.69824 1.55859 7.6709C1.91406 8.81934 2.98047 9.63965 4.23828 9.66699C3.25391 10.4326 2.02344 10.8975 0.683594 10.8975C0.4375 10.8975 0.21875 10.8701 0 10.8428C1.25781 11.6631 2.76172 12.1279 4.40234 12.1279C9.67969 12.1279 12.5508 7.78027 12.5508 3.97949C12.5508 3.84277 12.5508 3.7334 12.5508 3.59668Z"
        fill="#051036"
      />
    </svg>
  ),
  instagram: (
    <svg
      width="14"
      height="14"
      fill="#000000"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="5151e0c8492e5103c096af88a50059a5">
          <path
            display="inline"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#051036"
            d="M66.084,0.5h379.819c36.079,0,65.597,29.505,65.597,65.584 v379.819c0,36.079-29.518,65.597-65.597,65.597H66.084C30.005,511.5,0.5,481.982,0.5,445.903V66.084 C0.5,30.005,30.005,0.5,66.084,0.5L66.084,0.5z M372.734,57.264c-12.65,0-23.005,10.355-23.005,23.005v55.067 c0,12.65,10.354,23.005,23.005,23.005h57.762c12.65,0,23.005-10.354,23.005-23.005V80.269c0-12.65-10.354-23.005-23.005-23.005 H372.734L372.734,57.264z M453.738,216.59h-44.975c4.254,13.897,6.55,28.606,6.55,43.852c0,84.996-71.111,153.898-158.839,153.898 c-87.716,0-158.827-68.902-158.827-153.898c0-15.245,2.295-29.954,6.55-43.852H57.276v215.853c0,11.178,9.132,20.322,20.311,20.322 h355.841c11.166,0,20.311-9.145,20.311-20.322V216.59L453.738,216.59z M256.475,155.447c-56.677,0-102.625,44.525-102.625,99.443 s45.948,99.443,102.625,99.443c56.688,0,102.636-44.525,102.636-99.443S313.163,155.447,256.475,155.447z"
          ></path>
        </g>
      </g>
    </svg>
  ),
  linkedin: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.73438 12.6904V4.51465H0.191406V12.6904H2.73438ZM1.44922 3.4209C2.26953 3.4209 2.92578 2.7373 2.92578 1.91699C2.92578 1.12402 2.26953 0.467773 1.44922 0.467773C0.65625 0.467773 0 1.12402 0 1.91699C0 2.7373 0.65625 3.4209 1.44922 3.4209ZM12.2227 12.6904H12.25V8.20605C12.25 6.01855 11.7578 4.32324 9.1875 4.32324C7.95703 4.32324 7.13672 5.00684 6.78125 5.63574H6.75391V4.51465H4.32031V12.6904H6.86328V8.64355C6.86328 7.57715 7.05469 6.56543 8.36719 6.56543C9.67969 6.56543 9.70703 7.76855 9.70703 8.72559V12.6904H12.2227Z"
        fill="#051036"
      />
    </svg>
  ),
  checkMark: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_283_197)">
        <path
          d="M16.875 5.62539L8.125 14.375L3.75 10.0004"
          stroke="#1A1E25"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_283_197">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  doubleCheckMark: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_283_182)">
        <path
          d="M11.5625 6.5625L4.6875 13.4375L1.25 10.0002"
          stroke="url(#paint0_linear_283_182)"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M18.7498 6.5625L11.8748 13.4375L10.0488 11.6116"
          stroke="url(#paint1_linear_283_182)"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_283_182"
          x1="1.25"
          y1="6.9181"
          x2="7.11709"
          y2="15.8817"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#17c0ea" />
          <stop offset="1" stopColor="#17c0ea" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_283_182"
          x1="10.0488"
          y1="6.9181"
          x2="16.2498"
          y2="14.9114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#17c0ea" />
          <stop offset="1" stopColor="#17c0ea" />
        </linearGradient>
        <clipPath id="clip0_283_182">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  backAngle: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g data-name="Layer 2">
          <g data-name="arrow-ios-back">
            <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0"></rect>
            <path d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  uploadIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  newsLetterIcon: (
    <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.91922 2.95605L5.46296 7.49978L0.91922 12.0435L3.21999 14.3443L8.91412 8.65017C9.54946 8.01483 9.54946 6.98474 8.91412 6.3494L3.21999 0.655273L0.91922 2.95605Z"
        fill="white"
      />
    </svg>
  ),
  uploadCloud: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  uploadCloud: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  whatsappIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  linkedinIcon: (
    <svg width="18" height="18" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63 6.48529V58.5147C63 59.7043 62.5274 60.8451 61.6863 61.6863C60.8451 62.5274 59.7043 63 58.5147 63H6.48529C5.29572 63 4.15487 62.5274 3.31371 61.6863C2.47256 60.8451 2 59.7043 2 58.5147V6.48529C2 5.29572 2.47256 4.15487 3.31371 3.31371C4.15487 2.47256 5.29572 2 6.48529 2L58.5147 2C59.7043 2 60.8451 2.47256 61.6863 3.31371C62.5274 4.15487 63 5.29572 63 6.48529ZM19.9412 25.3235H10.9706V54.0294H19.9412V25.3235ZM20.7485 15.4559C20.7533 14.7773 20.6243 14.1045 20.369 13.4758C20.1137 12.8471 19.737 12.2748 19.2605 11.7917C18.7841 11.3085 18.2171 10.924 17.592 10.66C16.9669 10.3959 16.2959 10.2576 15.6174 10.2529H15.4559C14.076 10.2529 12.7526 10.8011 11.7768 11.7768C10.8011 12.7526 10.2529 14.076 10.2529 15.4559C10.2529 16.8358 10.8011 18.1592 11.7768 19.1349C12.7526 20.1107 14.076 20.6588 15.4559 20.6588C16.1345 20.6755 16.8097 20.5583 17.443 20.314C18.0763 20.0696 18.6553 19.7029 19.1468 19.2347C19.6383 18.7665 20.0327 18.2061 20.3076 17.5854C20.5824 16.9647 20.7322 16.296 20.7485 15.6174V15.4559ZM54.0294 36.5906C54.0294 27.9609 48.5394 24.6059 43.0853 24.6059C41.2995 24.5165 39.5215 24.8968 37.9286 25.709C36.3357 26.5212 34.9835 27.7369 34.0071 29.2347H33.7559V25.3235H25.3235V54.0294H34.2941V38.7615C34.1644 37.1978 34.657 35.6461 35.6648 34.4434C36.6726 33.2408 38.1142 32.4844 39.6765 32.3385H40.0174C42.87 32.3385 44.9871 34.1326 44.9871 38.6538V54.0294H53.9576L54.0294 36.5906Z"
        stroke="white"
        strokeWidth="3.05"
        strokeLinejoin="round"
      />
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  link: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.875 0.125L9.5 0.125C9.59946 0.125 9.69484 0.164509 9.76517 0.234835C9.83549 0.305161 9.875 0.400544 9.875 0.5V3.125C9.875 3.33211 9.70711 3.5 9.5 3.5C9.29289 3.5 9.125 3.33211 9.125 3.125V1.40533L3.01516 7.51517C2.86872 7.66161 2.63128 7.66161 2.48484 7.51517C2.33839 7.36872 2.33839 7.13128 2.48484 6.98483L8.59467 0.875L6.875 0.875C6.66789 0.875 6.5 0.707107 6.5 0.5C6.5 0.292893 6.66789 0.125 6.875 0.125ZM1.625 2.375C1.21079 2.375 0.875 2.71079 0.875 3.125V8.375C0.875 8.78921 1.21079 9.125 1.625 9.125H6.875C7.28921 9.125 7.625 8.78921 7.625 8.375V4.25C7.625 4.04289 7.79289 3.875 8 3.875C8.20711 3.875 8.375 4.04289 8.375 4.25V8.375C8.375 9.20343 7.70343 9.875 6.875 9.875H1.625C0.796573 9.875 0.125 9.20343 0.125 8.375V3.125C0.125 2.29657 0.796573 1.625 1.625 1.625H5.75C5.95711 1.625 6.125 1.79289 6.125 2C6.125 2.20711 5.95711 2.375 5.75 2.375H1.625Z"
        fill="#334155"
      />
    </svg>
  ),
  playIcon: (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="54.2472" cy="54.2472" r="54.2472" fill="white" />
      <circle cx="54.2451" cy="54.249" r="38.748" fill="white" />
      <path
        d="M65.8769 50.2192C68.9768 52.0089 68.9768 56.4831 65.8769 58.2728L51.9276 66.3265C48.8278 68.1161 44.953 65.879 44.953 62.2996L44.953 46.1924C44.953 42.613 48.8278 40.3759 51.9276 42.1656L65.8769 50.2192Z"
        fill="#121418"
      />
    </svg>
  ),
  whatsappIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  playIcon: (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="54.2472" cy="54.2472" r="54.2472" fill="white" />
      <circle cx="54.2451" cy="54.249" r="38.748" fill="white" />
      <path
        d="M65.8769 50.2192C68.9768 52.0089 68.9768 56.4831 65.8769 58.2728L51.9276 66.3265C48.8278 68.1161 44.953 65.879 44.953 62.2996L44.953 46.1924C44.953 42.613 48.8278 40.3759 51.9276 42.1656L65.8769 50.2192Z"
        fill="#121418"
      />
    </svg>
  ),
  linkedinIcon: (
    <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4063 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4063 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39063 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39063 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
        fill="white"
      />
    </svg>
  ),
  submitIcon: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1858 0.41959L16.1857 0.419492C15.9822 0.216133 15.6822 0.143742 15.4085 0.230747L15.4083 0.230827L1.33494 4.72522L1.33493 4.72523C1.02383 4.82461 0.809498 5.10962 0.800302 5.43607L0.8003 5.43613C0.791197 5.76253 0.989298 6.05918 1.29442 6.17575L7.90363 8.7017L10.4296 15.3109C10.5436 15.6093 10.8297 15.8053 11.1476 15.8053L11.1688 15.805L11.1693 15.805C11.4957 15.7958 11.7807 15.5815 11.8801 15.2704L11.8801 15.2704L16.3745 1.19708L16.3745 1.19705C16.462 0.923027 16.3892 0.623035 16.1858 0.41959ZM8.77352 7.38811L3.8924 5.52263L14.4564 2.1489L11.0827 12.7129L9.21723 7.83181C9.13915 7.62752 8.97782 7.46618 8.77352 7.38811Z"
        fill="#BBBBBB"
        stroke="#BBBBBB"
        strokeWidth="0.4"
      />
    </svg>
  ),
  whatsappIcon: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  playIcon: (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.5" cx="54.2472" cy="54.2472" r="54.2472" fill="white" />
      <circle cx="54.2451" cy="54.249" r="38.748" fill="white" />
      <path
        d="M65.8769 50.2192C68.9768 52.0089 68.9768 56.4831 65.8769 58.2728L51.9276 66.3265C48.8278 68.1161 44.953 65.879 44.953 62.2996L44.953 46.1924C44.953 42.613 48.8278 40.3759 51.9276 42.1656L65.8769 50.2192Z"
        fill="#121418"
      />
    </svg>
  ),
  linkedinIcon: (
    <svg width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4063 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4063 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39063 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39063 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
        fill="white"
      />
    </svg>
  ),
  reset: (
    <svg
      width="18"
      height="18"
      fill="#000000"
      viewBox="0 0 512 512"
      data-name="Layer 1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z"></path>
      </g>
    </svg>
  ),
  prevIcon: (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.54912 0.43256C5.8085 0.702317 5.80009 1.13127 5.53033 1.39065L1.97269 4.74196L5.53033 8.09326C5.80009 8.35265 5.8085 8.7816 5.54912 9.05135C5.28973 9.32111 4.86078 9.32952 4.59103 9.07014L0.525415 5.23039C0.392552 5.10264 0.317465 4.92628 0.317465 4.74196C0.317465 4.55764 0.392552 4.38127 0.525415 4.25352L4.59103 0.413774C4.86078 0.154393 5.28973 0.162804 5.54912 0.43256Z"
        fill="#202020"
      />
    </svg>
  ),
  nextIcon: (
    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.823931 9.05084C0.564549 8.78108 0.57296 8.35213 0.842717 8.09275L4.40035 4.74144L0.842716 1.39013C0.572959 1.13075 0.564549 0.701802 0.82393 0.432045C1.08331 0.162289 1.51226 0.153878 1.78202 0.413259L5.84763 4.253C5.9805 4.38076 6.05558 4.55712 6.05558 4.74144C6.05558 4.92576 5.9805 5.10213 5.84763 5.22988L1.78202 9.06962C1.51226 9.32901 1.08331 9.32059 0.823931 9.05084Z"
        fill="#202020"
      />
    </svg>
  ),
  filter: (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" style={{ fill: 'none' }}>
      <path
        d="M14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5M14 5H20M10 5L4 5M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM16 12H4M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19ZM8 19H20"
        stroke="#303030"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  gridIcon: (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.4142"
        y="1.62514"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
      <rect
        x="12.8165"
        y="1.62514"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
      <rect
        x="1.4142"
        y="13.026"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
      <rect
        x="12.8165"
        y="13.026"
        width="8.29962"
        height="8.29944"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
    </svg>
  ),
  tileIcon: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.736468"
        y="0.736468"
        width="19.5271"
        height="19.5271"
        rx="2.37936"
        stroke="#596780"
        strokeWidth="1.47294"
        fill="none"
      />
    </svg>
  ),
  legalProperty: (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="60.3209" cy="60.483" r="59.9107" fill="#0055FF" />
      <path
        d="M60.3173 96.8017C80.2876 96.8017 96.6269 80.4624 96.6269 60.4921C96.6269 40.5219 80.2876 24.1826 60.3173 24.1826C40.3471 24.1826 24.0078 40.5219 24.0078 60.4921C24.0078 80.4624 40.3471 96.8017 60.3173 96.8017Z"
        fill="#0055FF"
      />
      <path d="M43.3516 77.2439H78.6445V41.9511H43.3516V77.2439Z" fill="#777E91" />
    </svg>
  ),
  success: (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="60.4991" cy="60.483" r="59.9107" fill="#0055FF" />
      <path
        d="M60.496 96.8026C80.4663 96.8026 96.8056 80.4634 96.8056 60.4931C96.8056 40.5229 80.4663 24.1836 60.496 24.1836C40.5258 24.1836 24.1865 40.5229 24.1865 60.4931C24.1865 80.4634 40.5258 96.8026 60.496 96.8026Z"
        fill="#0055FF"
      />
      <path
        d="M45.0649 60.4924L55.3405 70.768L75.928 50.2168"
        stroke="white"
        fill="none"
        strokeWidth="6.53571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  inComplete: (
    <svg
      width="121"
      height="121"
      viewBox="0 0 121 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="60.4986" cy="60.483" r="59.9107" fill="#FF8E09" />
      <path d="M44.1063 75.4351H78.8928V40.6486H44.1063V75.4351Z" fill="black" />
    </svg>
  ),
  tiltedArrow: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.586 5.65692L6.636 1.70692C6.45384 1.51832 6.35305 1.26571 6.35533 1.00352C6.3576 0.741321 6.46277 0.490508 6.64818 0.3051C6.83359 0.119692 7.0844 0.0145233 7.3466 0.0122448C7.6088 0.00996641 7.8614 0.110761 8.05 0.292919L13.707 5.94992C13.8002 6.04257 13.8741 6.15273 13.9246 6.27407C13.9751 6.3954 14.001 6.52551 14.001 6.65692C14.001 6.78833 13.9751 6.91844 13.9246 7.03977C13.8741 7.16111 13.8002 7.27127 13.707 7.36392L8.05 13.0209C7.95775 13.1164 7.84741 13.1926 7.7254 13.245C7.6034 13.2974 7.47218 13.325 7.3394 13.3262C7.20662 13.3273 7.07494 13.302 6.95205 13.2517C6.82915 13.2015 6.7175 13.1272 6.62361 13.0333C6.52971 12.9394 6.45546 12.8278 6.40518 12.7049C6.3549 12.582 6.3296 12.4503 6.33075 12.3175C6.3319 12.1847 6.35949 12.0535 6.4119 11.9315C6.46431 11.8095 6.54049 11.6992 6.636 11.6069L10.586 7.65692H1C0.734784 7.65692 0.48043 7.55156 0.292893 7.36403C0.105357 7.17649 0 6.92214 0 6.65692C0 6.3917 0.105357 6.13735 0.292893 5.94981C0.48043 5.76228 0.734784 5.65692 1 5.65692H10.586Z"
        fill="#f15772"
      />
    </svg>
  ),
  favorite: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 680 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.3557 335.607L320.11 553.317C328.093 560.813 332.083 564.563 336.79 565.487C338.91 565.903 341.09 565.903 343.21 565.487C347.917 564.563 351.907 560.813 359.89 553.317L591.643 335.607C656.85 274.353 664.767 173.553 609.927 102.869L599.617 89.578C534.01 5.01932 402.32 19.2003 356.223 115.788C349.71 129.432 330.29 129.432 323.777 115.788C277.68 19.2003 145.991 5.01932 80.3847 89.5783L70.073 102.869C15.2317 173.553 23.15 274.353 88.3557 335.607Z"
        fill="#000"
        stroke="#000"
        strokeWidth="50"
      />
    </svg>
  ),
  unfavorite: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 680 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.6942 335.695L320.449 553.405C328.432 560.902 332.422 564.652 337.129 565.575C339.249 565.992 341.429 565.992 343.549 565.575C348.255 564.652 352.245 560.902 360.229 553.405L591.982 335.695C657.188 274.442 665.105 173.642 610.265 102.957L599.955 89.6664C534.348 5.10769 402.659 19.2887 356.562 115.877C350.049 129.52 330.629 129.52 324.115 115.877C278.019 19.2887 146.329 5.10769 80.7232 89.6667L70.4115 102.957C15.5702 173.642 23.4885 274.442 88.6942 335.695Z"
        stroke="#7D7F88"
        strokeWidth="50"
        fill="none"
      />
    </svg>
  ),
  location: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M12 21C15.5 17.4 19 14.1764 19 10.2C19 6.22355 15.866 3 12 3C8.13401 3 5 6.22355 5 10.2C5 14.1764 8.5 17.4 12 21Z"
          stroke="#8e8c8c"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
        <path
          d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
          stroke="#8e8c8c"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  login: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  commission: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 18C10.6675 18.6224 8.91707 19 7 19C5.93408 19 4.91969 18.8833 4 18.6726C3.4088 18.5372 3.11319 18.4695 2.75898 18.1892C2.55696 18.0294 2.30483 17.7129 2.19412 17.4803C2 17.0725 2 16.677 2 15.886V5.11397C2 4.12914 3.04003 3.45273 4 3.6726C4.91969 3.88325 5.93408 4 7 4C8.91707 4 10.6675 3.62236 12 3C13.3325 2.37764 15.0829 2 17 2C18.0659 2 19.0803 2.11675 20 2.3274C20.5912 2.46281 20.8868 2.53051 21.241 2.81079C21.443 2.97064 21.6952 3.28705 21.8059 3.51966C22 3.92751 22 4.32299 22 5.11397V15.886C22 16.8709 20.96 17.5473 20 17.3274C19.0803 17.1167 18.0659 17 17 17C15.0829 17 13.3325 17.3776 12 18Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M2 21C3.33254 21.6224 5.08293 22 7 22C8.91707 22 10.6675 21.6224 12 21C13.3325 20.3776 15.0829 20 17 20C18.9171 20 20.6675 20.3776 22 21"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M14.5 10.5C14.5 11.8807 13.3807 13 12 13C10.6193 13 9.5 11.8807 9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M5.5 11.5L5.5 11.509"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M18.5 9.49219L18.5 9.50117"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  shipping: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="18" r="2" stroke="#2A353D" strokeWidth="1.5" fill="none" />
      <circle cx="7" cy="18" r="2" stroke="#2A353D" strokeWidth="1.5" fill="none" />
      <path
        d="M5 17.9724C3.90328 17.9178 3.2191 17.7546 2.73223 17.2678C2.24536 16.7809 2.08222 16.0967 2.02755 15M9 18H15M19 17.9724C20.0967 17.9178 20.7809 17.7546 21.2678 17.2678C22 16.5355 22 15.357 22 13V11H17.3C16.5555 11 16.1832 11 15.882 10.9021C15.2731 10.7043 14.7957 10.2269 14.5979 9.61803C14.5 9.31677 14.5 8.94451 14.5 8.2C14.5 7.08323 14.5 6.52485 14.3532 6.07295C14.0564 5.15964 13.3404 4.44358 12.4271 4.14683C11.9752 4 11.4168 4 10.3 4H2"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2 8H8"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2 11H6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.5 6H16.3212C17.7766 6 18.5042 6 19.0964 6.35371C19.6886 6.70742 20.0336 7.34811 20.7236 8.6295L22 11"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  connections: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.774 18C21.5233 18 22.1193 17.5285 22.6545 16.8691C23.7499 15.5194 21.9513 14.4408 21.2654 13.9126C20.568 13.3756 19.7894 13.0714 19 13M18 11C19.3807 11 20.5 9.88071 20.5 8.5C20.5 7.11929 19.3807 6 18 6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M3.22596 18C2.47666 18 1.88067 17.5285 1.34555 16.8691C0.250089 15.5194 2.04867 14.4408 2.73465 13.9126C3.43197 13.3756 4.21058 13.0714 5 13M5.5 11C4.11929 11 3 9.88071 3 8.5C3 7.11929 4.11929 6 5.5 6"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M8.0838 15.1112C7.06203 15.743 4.38299 17.0331 6.0147 18.6474C6.81178 19.436 7.69952 20 8.81563 20H15.1844C16.3005 20 17.1882 19.436 17.9853 18.6474C19.617 17.0331 16.938 15.743 15.9162 15.1112C13.5201 13.6296 10.4799 13.6296 8.0838 15.1112Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  startSelling: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9961 10H11.0111M10.9998 16H11.0148"
        stroke="#2A353D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 13H15"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="matrix(1 0 0 -1 16 8.00024)"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.77423 11.1439C1.77108 12.2643 1.7495 13.9546 2.67016 15.1437C4.49711 17.5033 6.49674 19.5029 8.85633 21.3298C10.0454 22.2505 11.7357 22.2289 12.8561 21.2258C15.8979 18.5022 18.6835 15.6559 21.3719 12.5279C21.6377 12.2187 21.8039 11.8397 21.8412 11.4336C22.0062 9.63798 22.3452 4.46467 20.9403 3.05974C19.5353 1.65481 14.362 1.99377 12.5664 2.15876C12.1603 2.19608 11.7813 2.36233 11.472 2.62811C8.34412 5.31646 5.49781 8.10211 2.77423 11.1439Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  ),
  accessibility: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" fill="none"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" fill="none"></g>
      <g id="SVGRepo_iconCarrier">
        <circle cx="12" cy="12" r="10" stroke="#1C274C" strokeWidth="1.5" fill="none"></circle>
        <path
          d="M14 7C14 8.10457 13.1046 9 12 9C10.8954 9 10 8.10457 10 7C10 5.89543 10.8954 5 12 5C13.1046 5 14 5.89543 14 7Z"
          stroke="#1C274C"
          strokeWidth="1.5"
          fill="none"
        ></path>
        <path
          d="M18 10C18 10 14.4627 11.5 12 11.5C9.53727 11.5 6 10 6 10"
          stroke="#1C274C"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        ></path>
        <path
          d="M12 12V13.4522M12 13.4522C12 14.0275 12.1654 14.5906 12.4765 15.0745L15 19M12 13.4522C12 14.0275 11.8346 14.5906 11.5235 15.0745L9 19"
          stroke="#1C274C"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  sustainability: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Sustainability_approved">
          <path d="M393.33,141.86c-4.7-5.71-9.13-11.1-11.25-16.21-2.28-5.49-3-12.71-3.82-20.34-1.3-12.64-2.79-27-12.49-36.67s-24-11.19-36.67-12.5c-7.64-.79-14.85-1.54-20.35-3.81-5.1-2.12-10.5-6.56-16.21-11.26-10-8.22-21.3-17.53-35.63-17.53s-25.65,9.31-35.64,17.53c-5.71,4.7-11.1,9.14-16.21,11.26-5.49,2.27-12.71,3-20.34,3.81-12.64,1.31-27,2.79-36.67,12.49s-11.19,24-12.5,36.68c-.79,7.63-1.54,14.85-3.81,20.34-2.12,5.11-6.56,10.5-11.26,16.21-8.21,10-17.52,21.3-17.52,35.64s9.31,25.65,17.52,35.63c4.7,5.71,9.14,11.11,11.26,16.21,2.27,5.49,3,12.71,3.81,20.35,1.31,12.64,2.79,27,12.5,36.67s24,11.18,36.67,12.49c7.63.79,14.85,1.54,20.34,3.82,5.11,2.11,10.5,6.55,16.21,11.25,10,8.22,21.31,17.53,35.64,17.53s25.65-9.31,35.63-17.53c5.71-4.7,11.11-9.14,16.21-11.25,5.5-2.28,12.71-3,20.35-3.82,12.64-1.3,27-2.79,36.67-12.49s11.19-24,12.49-36.67c.79-7.64,1.54-14.85,3.82-20.35,2.12-5.1,6.55-10.5,11.25-16.21,8.22-10,17.53-21.3,17.53-35.63S401.55,151.85,393.33,141.86Zm-13.9,59.83c-5.33,6.48-10.84,13.18-14,20.76-3.28,7.92-4.2,16.8-5.09,25.38-1.1,10.6-2.13,20.61-7.32,25.8s-15.2,6.22-25.8,7.32c-8.58.89-17.46,1.81-25.38,5.09-7.58,3.14-14.28,8.65-20.75,14-8.4,6.91-16.32,13.43-24.2,13.43s-15.81-6.52-24.2-13.43c-6.48-5.33-13.18-10.84-20.75-14-7.92-3.28-16.8-4.2-25.39-5.09-10.6-1.1-20.61-2.13-25.8-7.32s-6.22-15.2-7.31-25.8c-.89-8.58-1.81-17.46-5.1-25.38-3.14-7.58-8.65-14.28-14-20.76C127.48,193.3,121,185.38,121,177.5s6.52-15.81,13.42-24.2c5.33-6.48,10.84-13.18,14-20.76,3.29-7.91,4.21-16.79,5.1-25.38,1.09-10.6,2.13-20.61,7.32-25.8S176,75.14,186.57,74C195.16,73.16,204,72.24,212,69c7.57-3.14,14.27-8.65,20.75-14,8.39-6.9,16.32-13.43,24.2-13.43s15.8,6.53,24.2,13.43c6.47,5.33,13.17,10.84,20.75,14,7.92,3.29,16.8,4.21,25.38,5.09,10.6,1.1,20.61,2.14,25.8,7.32s6.22,15.2,7.32,25.8c.89,8.59,1.81,17.47,5.09,25.38,3.14,7.58,8.65,14.28,14,20.76,6.91,8.39,13.43,16.32,13.43,24.2S386.34,193.3,379.43,201.69Z"></path>
          <path d="M259,94.77a84.89,84.89,0,1,0,84.88,84.89A84.89,84.89,0,0,0,259,94.77Zm45.79,67.67c-32.23,16.49-52.91,51.26-53.12,51.61a10.49,10.49,0,0,1-7.83,5.11,10.1,10.1,0,0,1-1.22.07,10.49,10.49,0,0,1-7.58-3.24l-23.43-24.47A10.5,10.5,0,1,1,226.81,177l14.42,15.06c9.8-13.36,28.59-35.3,54-48.32a10.5,10.5,0,0,1,9.57,18.7Z"></path>
          <path d="M342.73,350.57c-18.59-.89-53.46,1.21-78.31,25.17a79.82,79.82,0,0,0-7.2,8,79.82,79.82,0,0,0-7.2-8c-24.85-24-59.73-26.06-78.31-25.17a23.87,23.87,0,0,0-22.8,22.8c-.88,18.57,1.21,53.45,25.17,78.3,17.28,17.92,42.48,27.25,75,27.75.94,0,18.73,0,21.28-.14,30.11-1.35,53.63-10.61,70-27.61,24-24.85,26.06-59.73,25.18-78.3A23.87,23.87,0,0,0,342.73,350.57ZM227.46,421,221.9,437.8c.86.3,17.55,6.18,26.06,23.59-26.83-.65-47.33-8.11-60.92-22.21-19.27-20-20.9-49.28-20.15-65a5.94,5.94,0,0,1,5.68-5.67c15.67-.75,45,.88,65,20.15,13.5,13,20.9,32.35,22.08,57.53A67.75,67.75,0,0,0,227.46,421Zm99.93,18.15c-11.71,12.16-28.58,19.37-50.21,21.54a24.64,24.64,0,0,0,.6-5.12c.23-21.49-3.23-39.93-10.32-55.16a61.88,61.88,0,0,1,9.45-11.74c17.7-17.06,42.68-20.29,59.06-20.29,2.12,0,4.1,0,5.9.14a5.94,5.94,0,0,1,5.68,5.67C348.29,389.9,346.67,419.19,327.39,439.18Z"></path>
        </g>
      </g>
    </svg>
  ),
  community: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 128 128"
      id="Layer_1"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M64,42c-13.2,0-24,10.8-24,24s10.8,24,24,24s24-10.8,24-24S77.2,42,64,42z M64,82c-8.8,0-16-7.2-16-16s7.2-16,16-16 s16,7.2,16,16S72.8,82,64,82z"></path>
          <path d="M64,100.8c-14.9,0-29.2,6.2-39.4,17.1l-2.7,2.9l5.8,5.5l2.7-2.9c8.8-9.4,20.7-14.6,33.6-14.6s24.8,5.2,33.6,14.6l2.7,2.9 l5.8-5.5l-2.7-2.9C93.2,107.1,78.9,100.8,64,100.8z"></path>
          <path d="M97,47.9v8c9.4,0,18.1,3.8,24.6,10.7l5.8-5.5C119.6,52.7,108.5,47.9,97,47.9z"></path>
          <path d="M116.1,20c0-10.5-8.6-19.1-19.1-19.1S77.9,9.5,77.9,20S86.5,39.1,97,39.1S116.1,30.5,116.1,20z M85.9,20 c0-6.1,5-11.1,11.1-11.1s11.1,5,11.1,11.1s-5,11.1-11.1,11.1S85.9,26.1,85.9,20z"></path>
          <path d="M31,47.9c-11.5,0-22.6,4.8-30.4,13.2l5.8,5.5c6.4-6.9,15.2-10.7,24.6-10.7V47.9z"></path>
          <path d="M50.1,20C50.1,9.5,41.5,0.9,31,0.9S11.9,9.5,11.9,20S20.5,39.1,31,39.1S50.1,30.5,50.1,20z M31,31.1 c-6.1,0-11.1-5-11.1-11.1S24.9,8.9,31,8.9s11.1,5,11.1,11.1S37.1,31.1,31,31.1z"></path>
        </g>
      </g>
    </svg>
  ),
  groupIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14 2.20004C13.3538 2.06886 12.6849 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.6031 7.39687L12 12M16.6031 7.39687L16.2781 6.15129C16.0319 5.20771 16.369 4.11915 17.1487 3.33944L18.298 2.19006C18.6041 1.88401 19.0779 1.95969 19.1745 2.33007L19.6909 4.30912L21.6699 4.82548C22.0403 4.92211 22.116 5.39591 21.8099 5.70196L20.6606 6.85135C19.8809 7.63105 18.7923 7.96805 17.8487 7.72186L16.6031 7.39687Z"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  upload: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  image: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0)"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V4ZM21 4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4Z"
          fill="#0F0F0F"
        ></path>
        <path
          d="M4.80665 17.5211L9.1221 9.60947C9.50112 8.91461 10.4989 8.91461 10.8779 9.60947L14.0465 15.4186L15.1318 13.5194C15.5157 12.8476 16.4843 12.8476 16.8682 13.5194L19.1451 17.5039C19.526 18.1705 19.0446 19 18.2768 19H5.68454C4.92548 19 4.44317 18.1875 4.80665 17.5211Z"
          fill="#0F0F0F"
        ></path>
        <path
          d="M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z"
          fill="#0F0F0F"
        ></path>
      </g>
    </svg>
  ),
  removeIcon: (
    <svg
      width="10px"
      height="10px"
      viewBox="0 0 10 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth="1" fillRule="evenodd">
        <g transform="translate(-821.000000, -311.000000)">
          <g transform="translate(809.000000, 299.000000)">
            <path
              d="M21.5833333,16.5833333 L17.4166667,16.5833333 L17.4166667,12.4170833 C17.4166667,12.1866667 17.2391667,12 17.00875,12 C16.77875,12 16.5920833,12.18625 16.5920833,12.41625 L16.5883333,16.5833333 L12.4166667,16.5833333 C12.18625,16.5833333 12,16.7695833 12,17 C12,17.23 12.18625,17.4166667 12.4166667,17.4166667 L16.5875,17.4166667 L16.5833333,21.5829167 C16.5829167,21.8129167 16.7691667,21.9995833 16.9991667,22 L16.9995833,22 C17.2295833,22 17.41625,21.81375 17.4166667,21.58375 L17.4166667,17.4166667 L21.5833333,17.4166667 C21.8133333,17.4166667 22,17.23 22,17 C22,16.7695833 21.8133333,16.5833333 21.5833333,16.5833333"
              transform="translate(17.000000, 17.000000) rotate(-45.000000) translate(-17.000000, -17.000000) "
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  Costumes: (
    <svg
      fill="#000000"
      width={24}
      height={24}
      viewBox="0 0 556 800"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M555.682 768.117C532.608 510.763 553.226 597.975 464.386 373.516V289.536L500.866 173.819C503.554 165.292 502.197 156.005 497.182 148.602C473.424 113.536 461.133 68.2344 465.874 33.1922C468.251 15.6297 454.574 0 436.871 0H354.947C342.783 0 331.888 7.52187 327.577 18.9C315.822 49.9219 310.84 77.575 277.904 77.575C244.969 77.575 239.999 49.9625 228.23 18.9C223.916 7.52187 213.021 0 200.857 0H118.93C101.207 0 87.5521 15.6469 89.9255 33.1922C94.6646 68.2359 82.3755 113.537 58.6177 148.602C53.6036 156.005 52.2458 165.292 54.9333 173.819L91.413 289.536V373.516C2.55204 598.039 23.1536 511.197 0.119231 768.117C-1.41671 785.239 12.0833 800 29.2708 800H526.532C543.719 800 557.216 785.234 555.682 768.117ZM149.188 58.5359H180.647L185.996 72.6516C200.604 111.202 236.677 136.109 277.901 136.109C319.124 136.109 355.197 111.2 369.805 72.6516L375.154 58.5359H406.613C408.502 95.3828 420.643 134.919 440.952 169.18L413.657 255.761H142.144L114.849 169.18C135.16 134.919 147.302 95.3828 149.188 58.5359ZM405.847 314.298V349.83H149.952V314.298H405.847ZM61.2645 741.464C79.9052 531.18 62.3489 606.019 140.577 408.367H415.226C493.408 605.905 475.901 531.152 494.538 741.464H61.2645Z"
        fill="black"
      />
    </svg>
  ),
  SkatesBlades: (
    <svg
      fill="#000000"
      width={24}
      height={24}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 484.49 484.49"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M452.49,348.708v-38.297c0-25.32-19.757-49.62-44.978-55.321l-0.646-0.131c-0.794-0.143-79.617-14.362-103.028-19.653 c-11.502-2.6-21.592-15.225-21.592-27.018V13.666L60.401,33.8v305.568H0v30h39.003c-6.695,10.294-10.602,22.56-10.602,35.728 c0,36.242,29.485,65.728,65.728,65.728s65.728-29.485,65.728-65.728c0-13.168-3.907-25.434-10.602-35.728h52.064 c-6.695,10.294-10.602,22.56-10.602,35.728c0,36.242,29.485,65.728,65.728,65.728s65.728-29.485,65.728-65.728 c0-13.168-3.907-25.434-10.602-35.728h52.065c-6.695,10.294-10.602,22.56-10.602,35.728c0,36.242,29.485,65.728,65.729,65.728 c36.242,0,65.728-29.485,65.728-65.728C484.49,381.177,471.643,360.207,452.49,348.708z M90.401,61.201l161.845-14.688v47.676 h-57.351v30h57.351v40h-57.351v30h57.351v14.099c0,25.858,19.757,50.579,44.979,56.279c23.464,5.304,97.344,18.657,103.953,19.85 c11.582,2.771,21.313,14.606,21.313,25.995v28.958H90.401V61.201z M129.856,405.096c0,19.7-16.027,35.728-35.728,35.728 s-35.728-16.027-35.728-35.728c0-19.701,16.027-35.728,35.728-35.728S129.856,385.396,129.856,405.096z M292.173,405.096 c0,19.7-16.027,35.728-35.728,35.728s-35.728-16.027-35.728-35.728c0-19.701,16.027-35.728,35.728-35.728 S292.173,385.396,292.173,405.096z M418.763,440.824c-19.701,0-35.729-16.027-35.729-35.728c0-19.701,16.027-35.728,35.729-35.728 c19.7,0,35.728,16.027,35.728,35.728C454.49,424.797,438.463,440.824,418.763,440.824z"></path>
      </g>
    </svg>
  ),
  Practicewear: (
    <svg
      fill="#000000"
      height={24}
      width={24}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 481.758 481.758"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M479.832,173.064c-5.238-10.529-51.881-103.35-76.299-119.953c-23.49-15.975-81.035-40.607-83.474-41.648l-2.809-1.199 l-3,0.575c-0.486,0.093-48.893,9.319-73.372,9.319c-24.46,0-72.886-9.226-73.372-9.319l-3-0.575l-2.809,1.199 c-2.439,1.041-59.983,25.673-83.474,41.647C53.807,69.715,7.164,162.535,1.926,173.064L0,176.935l1.5,4.054 c0.628,1.698,16.181,41.7,84.724,50.834l5.941,0.792l21.049-29.278c9.468,54.128-4.04,181.588-20.761,242.943l-2.404,8.822 l8.573,3.182c1.453,0.54,36.8,13.209,142.256,13.209c105.457,0,140.803-12.669,142.256-13.209l8.573-3.182l-2.404-8.822 c-16.721-61.357-30.229-188.816-20.761-242.943l21.049,29.277l5.941-0.792c68.543-9.134,84.096-49.135,84.724-50.834l1.501-4.054 L479.832,173.064z M295.906,34.326c-9.83,11.487-27.107,24.458-55.027,24.458c-27.927,0-45.206-12.978-55.031-24.459 c16.873,2.703,39.72,5.833,55.031,5.833C256.189,40.158,279.033,37.028,295.906,34.326z M449.647,189.089 c-8.602,7.68-24.27,17.473-50.885,22.019l-35.354-49.177l-7.459,14.588c-7.189,14.061-14.467,47.952-8.305,129.557 c3.671,48.618,11.303,100.419,19.876,135.773c-15.403,3.477-53.097,9.644-126.641,9.644c-66.914,0-108.029-5.398-126.654-9.591 c8.579-35.354,16.217-87.185,19.89-135.826c6.162-81.604-1.115-115.496-8.304-129.557l-7.459-14.588L82.994,211.11 c-40.559-6.89-56.063-25.702-60.913-33.626c19.342-38.317,52.823-97.93,67.389-107.835c16.771-11.405,54.511-28.546,71.503-36.05 c2.966,5.069,7.445,11.601,13.757,18.094c12.016,12.358,33.245,27.091,66.148,27.091c32.903,0,54.133-14.732,66.148-27.091 c6.312-6.492,10.791-13.024,13.758-18.094c16.991,7.504,54.73,24.646,71.502,36.051c14.556,9.897,48.027,69.486,67.375,107.807 C457.92,180.256,454.789,184.496,449.647,189.089z"></path>
      </g>
    </svg>
  ),
  Accessories: (
    <svg
      width={24}
      height={24}
      version="1.1"
      id="Uploaded to svgrepo.com"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.96 -0.96 33.92 33.92"
      fill="#000000"
      strokeWidth="0.41600000000000004"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          className="feather_een"
          d="M21.879,20.222C21.316,19.659,21,18.896,21,18.1v-5.284c1.163-0.413,2-1.512,2-2.816V8 c0-1.304-0.837-2.403-2-2.816V4c0-1.105-0.895-2-2-2c0-1.105-0.895-2-2-2h-3c-1.105,0-2,0.895-2,2v3h-1.969 C10.463,4.151,11,2.996,11,2.5C11,1.672,10.328,1,9.5,1S8,1.672,8,2.5c0,0.53,0.612,1.81,1.054,2.667C7.864,5.565,7,6.676,7,8v2 c0,1.304,0.837,2.403,2,2.816v6.385c0,2.652,1.054,5.196,2.929,7.071L16,30.343C17.105,31.448,18.552,32,20,32 c1.448,0,2.895-0.552,4-1.657c2.209-2.209,2.209-5.791,0-8L21.879,20.222z M19,3c0.551,0,1,0.449,1,1v1h-4V4c0-0.551,0.449-1,1-1H19 z M13,2c0-0.551,0.449-1,1-1h3c0.551,0,1,0.449,1,1h-1c-1.105,0-2,0.895-2,2v1h-2V2z M9,2.5C9,2.224,9.224,2,9.5,2 S10,2.224,10,2.486C9.984,2.682,9.788,3.188,9.5,3.81C9.212,3.191,9.016,2.689,9,2.5z M8,10V8c0-1.103,0.897-2,2-2h10 c1.103,0,2,0.897,2,2v2c0,1.103-0.897,2-2,2H10C8.897,12,8,11.103,8,10z M12.636,25.565c-1.7-1.7-2.636-3.96-2.636-6.364V18.49 c2.274,0.467,4,2.443,4,4.853c0,1.016-0.326,1.946-0.853,2.733L12.636,25.565z M23.293,29.636C22.413,30.516,21.244,31,20,31 s-2.413-0.484-3.293-1.364l-2.837-2.837C14.569,25.82,15,24.638,15,23.343c0-2.972-2.163-5.433-5-5.909V13h10v5.1 c0,1.068,0.416,2.073,1.172,2.828l2.121,2.121C25.109,24.866,25.109,27.82,23.293,29.636z"
        ></path>
      </g>
    </svg>
  ),
  sorting: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.4697 7.53033C13.7626 7.82322 14.2374 7.82322 14.5303 7.53033L15.25 6.81066L15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17L16.75 6.81066L17.4697 7.53033C17.7626 7.82322 18.2374 7.82322 18.5303 7.53033C18.8232 7.23744 18.8232 6.76256 18.5303 6.46967L16.5303 4.46967C16.2374 4.17678 15.7626 4.17678 15.4697 4.46967L13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033Z"
        fill="black"
      />
      <path
        d="M8.75 17.1893L9.46967 16.4697C9.76256 16.1768 10.2374 16.1768 10.5303 16.4697C10.8232 16.7626 10.8232 17.2374 10.5303 17.5303L8.53033 19.5303C8.23744 19.8232 7.76256 19.8232 7.46967 19.5303L5.46967 17.5303C5.17678 17.2374 5.17678 16.7626 5.46967 16.4697C5.76256 16.1768 6.23744 16.1768 6.53033 16.4697L7.25 17.1893L7.25 7C7.25 6.58579 7.58579 6.25 8 6.25C8.41421 6.25 8.75 6.58579 8.75 7L8.75 17.1893Z"
        fill="black"
      />
    </svg>
  ),
  trash: (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M18 6L17.1991 18.0129C17.129 19.065 17.0939 19.5911 16.8667 19.99C16.6666 20.3412 16.3648 20.6235 16.0011 20.7998C15.588 21 15.0607 21 14.0062 21H9.99377C8.93927 21 8.41202 21 7.99889 20.7998C7.63517 20.6235 7.33339 20.3412 7.13332 19.99C6.90607 19.5911 6.871 19.065 6.80086 18.0129L6 6M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M14 10V17M10 10V17"
          stroke="#000000"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  suitcase: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g>
          {' '}
          <g>
            {' '}
            <path d="M349.659,106.146v-31.22c0-24.1-19.607-43.707-43.707-43.707h-99.902c-24.1,0-43.707,19.607-43.707,43.707v31.22H0V480.78 h512V106.146H349.659z M199.805,74.927c0-3.443,2.801-6.244,6.244-6.244h99.902c3.443,0,6.244,2.801,6.244,6.244v31.22h-112.39 V74.927z M474.537,443.317H37.463V273.646c53.668,19.108,124.105,30.487,199.805,32.102v31.422h37.463v-31.422 c75.7-1.616,146.137-12.995,199.805-32.102V443.317z M474.537,233.593c-50.262,20.311-122.881,32.9-199.805,34.671v-30.996 h-37.463v30.995c-76.924-1.771-149.543-14.36-199.805-34.671V143.61h437.073V233.593z"></path>{' '}
          </g>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  landscape: (
    <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M3 20h18a1 1 0 0 0 .864-1.504l-7-12c-.359-.615-1.369-.613-1.729 0L9.866 12.1l-1.02-1.632A.998.998 0 0 0 8 10h-.001a1 1 0 0 0-.847.47l-5 8A1 1 0 0 0 3 20zM14 8.985 19.259 18h-5.704l-2.486-3.987L14 8.985zm-5.999 3.9L11.197 18H4.805l3.196-5.115zM6 8c1.654 0 3-1.346 3-3S7.654 2 6 2 3 3.346 3 5s1.346 3 3 3zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
      </g>
    </svg>
  ),
  plumbing: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M83.478,189.217c-9.22,0-16.696,7.475-16.696,16.696v217.044c0,9.22,7.475,16.696,16.696,16.696 s16.696-7.475,16.696-16.696V205.913C100.174,196.693,92.699,189.217,83.478,189.217z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M463.432,139.133l-75.472,0.126c-19.699,0.031-38.916,3.862-57.121,11.384l-130.491,50.205V152.72l131.898-49.278 c20.674-6.501,35.059-26.065,35.059-47.79c0-27.618-22.469-50.087-50.087-50.087c-0.598,0-1.194,0.032-1.789,0.096L73.407,31.74 c-0.095,0.011-0.188,0.022-0.283,0.033C31.437,36.985,0,72.596,0,114.607c0,11.418,0,358.294,0,375.132 c0,9.22,7.475,16.696,16.696,16.696h166.956c9.22,0,16.696-7.475,16.696-16.696v-91.787l153.067-113.924 c0.156-0.116,0.309-0.235,0.461-0.356c7.084-5.667,15.622-9.288,24.559-10.509v26.665c0,21.864,17.788,39.651,39.652,39.651 h10.435h10.435c21.865,0,39.652-17.788,39.652-39.652v-28.833C497.847,265.597,512,247.914,512,226.975V187.62 C512,161.035,490.535,139.126,463.432,139.133z M166.957,473.043H33.391V155.826h133.565V473.043z M185.648,122.566 c-0.656-0.078-1.319-0.13-1.996-0.13H33.391v-7.828c0-25.164,18.794-46.5,43.742-49.685l240.83-25.95 c8.861,0.391,15.95,7.722,15.95,16.679c0,7.312-4.881,13.889-11.868,15.992c-0.347,0.105-0.69,0.22-1.029,0.347L185.648,122.566z M445.217,299.826c0,3.453-2.808,6.261-6.261,6.261h-20.87c-3.453,0-6.261-2.808-6.261-6.261v-27.13h33.391V299.826z M478.61,226.975h-0.001c0,6.798-5.531,12.329-12.33,12.329h-81.113c-18.78,0-37.2,6.424-51.907,18.1l-132.911,98.922V236.625 l142.679-54.894c0.135-0.052,0.269-0.107,0.403-0.163c14.207-5.894,29.207-8.894,44.587-8.92l75.472-0.126 c0.009,0,0.018,0,0.026,0c8.28,0,15.095,6.692,15.095,15.096V226.975z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M440.948,345.022c-3.167-3.527-7.684-5.544-12.426-5.544s-9.259,2.017-12.426,5.544 c-18.504,20.644-54.357,65.857-54.357,94.63c0,36.824,29.959,66.783,66.783,66.783s66.783-29.959,66.783-66.783 C495.304,410.971,459.543,365.768,440.948,345.022z M428.522,473.043c-18.412,0-33.391-14.979-33.391-33.391 c0-10.642,15.692-35.497,33.391-57.627c17.701,22.132,33.391,46.985,33.391,57.627 C461.913,458.064,446.934,473.043,428.522,473.043z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  electrical: (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4164 31H29.5837C30.0096 30.0175 30.5783 29.0337 31.1077 28.1972C31.9501 26.8663 32.8498 25.6684 33.3793 25.0221C34.7882 23.2987 35.668 21.225 35.9229 19.0407C36.1778 16.8563 35.798 14.6443 34.8245 12.6584C33.8509 10.6721 32.3213 8.98968 30.4066 7.80939C28.4915 6.62888 26.2713 6.00036 24.0019 6C21.7326 5.99964 19.5121 6.62747 17.5967 7.80738C15.6816 8.98707 14.1514 10.6691 13.1771 12.6551C12.203 14.6407 11.8225 16.8525 12.0767 19.037C12.3308 21.2216 13.2102 23.2957 14.6187 25.0197C15.1472 25.6656 16.0473 26.8635 16.8906 28.1951C17.4206 29.032 17.9901 30.0165 18.4164 31ZM34.9273 26.2885C36.5762 24.2717 37.6099 21.8396 37.9094 19.2725C38.209 16.7053 37.7621 14.1074 36.6204 11.7782C35.4787 9.44891 33.6885 7.48298 31.4561 6.10687C29.2237 4.73075 26.6398 4.00041 24.0022 4C21.3646 3.99959 18.7806 4.72911 16.5477 6.10453C14.3149 7.47995 12.524 9.44531 11.3816 11.7742C10.2391 14.1031 9.79137 16.7008 10.0901 19.2681C10.3888 21.8354 11.4217 24.2678 13.0699 26.2851C14.0324 27.4611 16.4803 30.8176 17 33H31C31.5197 30.8193 33.9648 27.4628 34.9273 26.2885Z"
          fill="#333333"
        ></path>
        <path d="M19 21L25 12V18H29L23 27L23 21H19Z" fill="#333333"></path>
        <path d="M17 35H31V37H17V35Z" fill="#333333"></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29 41H19L19 42H29V41ZM17 39V42C17 43.1046 17.8954 44 19 44H29C30.1046 44 31 43.1046 31 42V39H17Z"
          fill="#333333"
        ></path>
      </g>
    </svg>
  ),
  remodel: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 481 481"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <g>
              <path d="M203.071,84.461l-34.33-78.469C167.149,2.352,163.553,0,159.581,0c-3.973,0-7.569,2.352-9.162,5.992l-34.33,78.469 c-0.562,1.283-0.822,2.648-0.822,4.008h-0.017V471c0,5.522,4.477,10,10,10h68.66c5.523,0,10-4.478,10-10V88.469h-0.016 C203.894,87.109,203.633,85.744,203.071,84.461z M159.581,34.949l19.04,43.52h-38.08L159.581,34.949z M135.251,367.818V98.469 h14.33v269.35L135.251,367.818L135.251,367.818z M183.911,461h-48.66v-43.756h48.66V461z M183.911,397.244h-48.66v-9.426h48.66 V397.244z M183.911,367.819h-14.33v-0.001V98.469h14.33V367.819z"></path>
              <path d="M355.75,0H228.24c-5.523,0-10,4.477-10,10v461c0,5.522,4.477,10,10,10H355.75c5.523,0,10-4.478,10-10V10 C365.75,4.477,361.273,0,355.75,0z M238.24,461v-53.565h48.851v-20H238.24v-58.467h48.851v-20H238.24V250.5h48.851v-20H238.24 v-58.469h48.851v-20H238.24V93.564h48.851v-20H238.24V20h78.085v406.861h20V20h9.425v441H238.24z"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  roof: (
    <svg
      fill="#000000"
      height="200px"
      width="200px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511.999 511.999"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M55.765,281.347v126.738h121.158V281.347H55.765z M146.506,377.668H86.182v-65.904h60.323V377.668z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M335.076,408.085h121.158V281.347H335.076V408.085z M365.493,311.764h60.323v65.904h-60.323V311.764z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M350.752,48.154H161.247L0,200.787v29.865v30.417v202.776h195.421h121.158h195.421V261.069v-30.417v-29.865 L350.752,48.154z M30.417,213.877L173.36,78.571h165.279l142.943,135.306v16.774H30.417V213.877z M286.161,433.428h-60.323v-0.001 V311.764h60.323V433.428z M481.583,433.427H316.579v-152.08H195.421v152.081H30.417V261.069h451.166V433.427z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  message: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M8 11H8.01M12 11H12.01M16 11H16.01M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  flash: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M6.08998 13.28H9.17998V20.48C9.17998 22.16 10.09 22.5 11.2 21.24L18.77 12.64C19.7 11.59 19.31 10.72 17.9 10.72H14.81V3.52002C14.81 1.84002 13.9 1.50002 12.79 2.76002L5.21998 11.36C4.29998 12.42 4.68998 13.28 6.08998 13.28Z"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>{' '}
      </g>
    </svg>
  ),
  shelter: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M2 12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274C22 8.77128 22 9.91549 22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039Z"
          stroke="#1C274C"
          strokeWidth="1.5"
        ></path>{' '}
        <path d="M15 18H9" stroke="#1C274C" strokeWidth="1.5" strokeLinecap="round"></path>{' '}
      </g>
    </svg>
  ),
  browse: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 720 720"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M664 344.001C664 280.711 645.232 218.841 610.07 166.217C574.909 113.594 524.934 72.578 466.461 48.3582C407.987 24.138 343.645 17.8017 281.571 30.1492C219.497 42.4964 162.479 72.9745 117.727 117.727C72.9738 162.48 42.496 219.497 30.1485 281.571C17.8013 343.646 24.1395 407.988 48.3594 466.459C72.5795 524.932 113.595 574.91 166.219 610.071C218.843 645.233 280.71 664.001 344 664.001"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M24 344.001H664"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M344 664.001C282.24 664.001 232 520.641 232 344.001C232 167.36 282.24 24.0001 344 24.0001C405.76 24.0001 456 167.36 456 344.001"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M547.811 659.841C609.667 659.841 659.811 609.697 659.811 547.841C659.811 485.985 609.667 435.841 547.811 435.841C485.955 435.841 435.811 485.985 435.811 547.841C435.811 609.697 485.955 659.841 547.811 659.841Z"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M695.994 696.004L626.874 627.204"
        stroke="black"
        strokeWidth="48"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  checkout: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 750 750"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M567.7 267.7C572.394 263.006 575.032 256.639 575.032 250C575.032 243.361 572.394 236.994 567.7 232.3C563.006 227.606 556.639 224.968 550 224.968C543.361 224.968 536.994 227.606 532.3 232.3L400 364.65L342.7 307.3C340.376 304.976 337.616 303.132 334.579 301.874C331.542 300.616 328.287 299.968 325 299.968C321.713 299.968 318.458 300.616 315.421 301.874C312.384 303.132 309.624 304.976 307.3 307.3C304.976 309.624 303.132 312.384 301.874 315.421C300.616 318.458 299.968 321.713 299.968 325C299.968 328.287 300.616 331.542 301.874 334.579C303.132 337.616 304.976 340.376 307.3 342.7L382.3 417.7C384.622 420.028 387.381 421.875 390.418 423.136C393.456 424.396 396.712 425.045 400 425.045C403.288 425.045 406.544 424.396 409.582 423.136C412.619 421.875 415.378 420.028 417.7 417.7L567.7 267.7Z"
        fill="black"
      />
      <path
        d="M25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50H80.5L100.55 130.35L175.45 529.6C176.522 535.329 179.563 540.503 184.046 544.228C188.528 547.953 194.172 549.995 200 550H250C223.478 550 198.043 560.536 179.289 579.289C160.536 598.043 150 623.478 150 650C150 676.522 160.536 701.957 179.289 720.711C198.043 739.464 223.478 750 250 750C276.522 750 301.957 739.464 320.711 720.711C339.464 701.957 350 676.522 350 650C350 623.478 339.464 598.043 320.711 579.289C301.957 560.536 276.522 550 250 550H600C573.478 550 548.043 560.536 529.289 579.289C510.536 598.043 500 623.478 500 650C500 676.522 510.536 701.957 529.289 720.711C548.043 739.464 573.478 750 600 750C626.522 750 651.957 739.464 670.711 720.711C689.464 701.957 700 676.522 700 650C700 623.478 689.464 598.043 670.711 579.289C651.957 560.536 626.522 550 600 550H650C655.828 549.995 661.472 547.953 665.954 544.228C670.437 540.503 673.478 535.329 674.55 529.6L749.55 129.6C750.225 125.992 750.098 122.279 749.177 118.726C748.255 115.173 746.563 111.866 744.22 109.04C741.876 106.215 738.939 103.94 735.618 102.378C732.296 100.815 728.671 100.003 725 100H144.5L124.25 18.95C122.9 13.5392 119.781 8.73494 115.387 5.30124C110.993 1.86753 105.577 0.00154057 100 0H25ZM220.75 500L155.1 150H694.9L629.25 500H220.75ZM300 650C300 663.261 294.732 675.979 285.355 685.355C275.979 694.732 263.261 700 250 700C236.739 700 224.021 694.732 214.645 685.355C205.268 675.979 200 663.261 200 650C200 636.739 205.268 624.021 214.645 614.645C224.021 605.268 236.739 600 250 600C263.261 600 275.979 605.268 285.355 614.645C294.732 624.021 300 636.739 300 650ZM650 650C650 663.261 644.732 675.979 635.355 685.355C625.979 694.732 613.261 700 600 700C586.739 700 574.021 694.732 564.645 685.355C555.268 675.979 550 663.261 550 650C550 636.739 555.268 624.021 564.645 614.645C574.021 605.268 586.739 600 600 600C613.261 600 625.979 605.268 635.355 614.645C644.732 624.021 650 636.739 650 650Z"
        fill="black"
      />
    </svg>
  ),
  delivery: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 671 537"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M651 241.333L616.667 193.667C608.982 182.874 598.835 174.069 587.067 167.982C575.299 161.895 562.249 158.701 549 158.667H403V87.3333C403 65.232 394.22 44.0358 378.592 28.4078C362.964 12.7797 341.768 4 319.667 4H87.3333C65.2509 4.06157 44.0905 12.8611 28.4758 28.4758C12.8611 44.0905 4.06157 65.2509 4 87.3333V418.667C4 431.927 9.26784 444.645 18.6447 454.022C28.0215 463.399 40.7392 468.667 54 468.667H94.6667C97.1837 486.501 106.057 502.827 119.654 514.639C133.25 526.452 150.655 532.956 168.667 532.956C186.678 532.956 204.083 526.452 217.68 514.639C231.276 502.827 240.15 486.501 242.667 468.667H428C430.517 486.501 439.39 502.827 452.987 514.639C466.584 526.452 483.989 532.956 502 532.956C520.011 532.956 537.416 526.452 551.013 514.639C564.61 502.827 573.483 486.501 576 468.667H616.667C629.928 468.667 642.645 463.399 652.022 454.022C661.399 444.645 666.667 431.927 666.667 418.667V289.667C666.585 272.32 661.11 255.429 651 241.333ZM168.667 499.667C160.426 499.667 152.37 497.223 145.518 492.645C138.666 488.066 133.325 481.559 130.172 473.945C127.018 466.332 126.193 457.954 127.801 449.871C129.408 441.789 133.377 434.364 139.204 428.537C145.031 422.71 152.455 418.742 160.538 417.134C168.62 415.526 176.998 416.351 184.612 419.505C192.225 422.659 198.733 427.999 203.311 434.851C207.89 441.703 210.333 449.759 210.333 458C210.333 469.051 205.943 479.649 198.129 487.463C190.315 495.277 179.717 499.667 168.667 499.667ZM369.667 435.333H240.333C235.48 420.137 225.922 406.878 213.04 397.469C200.158 388.06 184.619 382.99 168.667 382.99C152.715 382.99 137.175 388.06 124.293 397.469C111.411 406.878 101.853 420.137 97 435.333H54C49.5797 435.333 45.3405 433.577 42.2149 430.452C39.0893 427.326 37.3333 423.087 37.3333 418.667V87.3333C37.3333 74.0725 42.6012 61.3548 51.978 51.978C61.3548 42.6012 74.0725 37.3333 87.3333 37.3333H319.667C332.927 37.3333 345.645 42.6012 355.022 51.978C364.399 61.3548 369.667 74.0725 369.667 87.3333V435.333ZM502 499.667C493.759 499.667 485.703 497.223 478.851 492.645C471.999 488.066 466.659 481.559 463.505 473.945C460.351 466.332 459.526 457.954 461.134 449.871C462.742 441.789 466.71 434.364 472.537 428.537C478.364 422.71 485.789 418.742 493.871 417.134C501.954 415.526 510.332 416.351 517.945 419.505C525.559 422.659 532.066 427.999 536.645 434.851C541.223 441.703 543.667 449.759 543.667 458C543.667 469.051 539.277 479.649 531.463 487.463C523.649 495.277 513.051 499.667 502 499.667ZM633.333 418.667C633.333 423.087 631.577 427.326 628.452 430.452C625.326 433.577 621.087 435.333 616.667 435.333H573.667C568.813 420.137 559.255 406.878 546.373 397.469C533.491 388.06 517.952 382.99 502 382.99C486.048 382.99 470.509 388.06 457.627 397.469C444.745 406.878 435.187 420.137 430.333 435.333H403V192H549C556.953 192.053 564.781 193.983 571.847 197.632C578.914 201.281 585.019 206.546 589.667 213L624 260.667C629.999 269.154 633.256 279.274 633.333 289.667V418.667Z"
        fill="black"
        stroke="black"
        strokeWidth="8"
      />
      <path
        d="M536.3 275.333H469.633C465.213 275.333 460.974 273.577 457.848 270.452C454.723 267.326 452.967 263.087 452.967 258.667C452.967 254.246 454.723 250.007 457.848 246.882C460.974 243.756 465.213 242 469.633 242H536.3C540.72 242 544.959 243.756 548.085 246.882C551.211 250.007 552.967 254.246 552.967 258.667C552.967 263.087 551.211 267.326 548.085 270.452C544.959 273.577 540.72 275.333 536.3 275.333Z"
        fill="black"
        stroke="black"
        strokeWidth="8"
      />
    </svg>
  ),
  trackingPlane: (
    <svg fill="#000000" height="15px" width="20px" version="1.1" id="Layer_1" viewBox="0 0 128 128">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path d="M56.1,11.2c0-9.1,13.8-9.1,13.8,0.3v38.3L123.4,82v14.1L70.1,78.6v28.6l12.3,9.7V128l-19-5.9l-19,5.9v-11.2l12.2-9.7V78.6 L3.2,96.1V82l52.8-32.2V11.2z"></path>{' '}
      </g>
    </svg>
  ),
  orderIssues: (
    <svg
      width={24}
      height={16}
      fill="#000000"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M960 1242.342c62.23 0 112.941 50.71 112.941 112.94 0 62.231-50.71 112.942-112.941 112.942-62.23 0-112.941-50.71-112.941-112.941 0-62.23 50.71-112.941 112.941-112.941Zm89.336-892.01c114.862 29.704 208.264 123.106 237.968 237.967 23.378 90.466 10.729 183.304-35.464 261.46-45.515 77.138-121.186 133.947-207.586 156.084-13.779 3.614-27.783 14.795-27.783 31.962v91.595H903.529v-91.595c0-66.183 46.306-124.235 112.716-141.29 57.6-14.795 107.971-52.743 138.353-104.131 30.833-52.292 39.19-114.635 23.378-175.85-19.651-75.67-81.204-137.223-156.875-156.875-70.927-18.183-143.435-3.953-199.341 39.304-55.68 43.143-87.642 108.31-87.642 178.673H621.176c0-105.6 47.888-203.294 131.464-268.01 83.69-64.828 191.774-86.287 296.696-59.294ZM960-.01c-529.355 0-960 430.644-960 960 0 529.355 430.645 960 960 960 529.468 0 960-430.645 960-960 0-529.356-430.532-960-960-960"
          fillRule="evenodd"
        ></path>{' '}
      </g>
    </svg>
  ),
  deliveryInfo: (
    <svg
      width={24}
      height={16}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <rect x="0" fill="none" width="24" height="24"></rect>{' '}
        <g>
          {' '}
          <path d="M18 8h-2V7c0-1.105-.895-2-2-2H4c-1.105 0-2 .895-2 2v10h2c0 1.657 1.343 3 3 3s3-1.343 3-3h4c0 1.657 1.343 3 3 3s3-1.343 3-3h2v-5l-4-4zM7 18.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5zM4 14V7h10v7H4zm13 4.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5z"></path>{' '}
        </g>{' '}
      </g>
    </svg>
  ),
  lock: (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 8V6C14 3.23858 11.7614 1 9 1C6.23858 1 4 3.23858 4 6V8M9 12.5V14.5M5.8 19H12.2C13.8802 19 14.7202 19 15.362 18.673C15.9265 18.3854 16.3854 17.9265 16.673 17.362C17 16.7202 17 15.8802 17 14.2V12.8C17 11.1198 17 10.2798 16.673 9.63803C16.3854 9.07354 15.9265 8.6146 15.362 8.32698C14.7202 8 13.8802 8 12.2 8H5.8C4.11984 8 3.27976 8 2.63803 8.32698C2.07354 8.6146 1.6146 9.07354 1.32698 9.63803C1 10.2798 1 11.1198 1 12.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>
  ),
  headphone: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 16V10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10V16M3.5 19C2.11929 19 1 17.8807 1 16.5V14.5C1 13.1193 2.11929 12 3.5 12C4.88071 12 6 13.1193 6 14.5V16.5C6 17.8807 4.88071 19 3.5 19ZM16.5 19C15.1193 19 14 17.8807 14 16.5V14.5C14 13.1193 15.1193 12 16.5 12C17.8807 12 19 13.1193 19 14.5V16.5C19 17.8807 17.8807 19 16.5 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>
  ),
};

const Icons = ({ name }) => {
  return icons[name] || <></>;
};

export default Icons;
